<script>
import actionPermissionsMixins from "@/mixins/actionPermissionsMixins";
import EntityService from "@/services/entityService.js";
import authService from "@/services/authService";
import useColaboradorStore from "@/api/v2/stores/ColaboradorStore.js";
import UtilDateTime from "@/utils/UtilDateTime";
import UtilCapaPropostaPDF from "@/utils/UtilCapaPropostaPDF";
import { fecharModalComRecarregamentoGrid } from "@/utils/modalGridReloadRule.js";
import CartaoListaDeSolicitacoes from "./ListaDeDados/CartaoListaDeSolicitacoes.vue";
import ModalSolicitacaoDeOrcamento from "./Formulario/ModalSolicitacaoDeOrcamento.vue";
import {
  criarFormularioPadrao,
  criarItemPadrao,
  normalizarItem,
  calcularCamposDeItens,
  formatarNumeroInput,
  gerarPayloadPersistencia,
  normalizaListaSalesOrder,
  parseNumero,
  recalcularCamposPreco,
  recalcularCamposComerciaisItem,
  STATUS_EM_EXECUCAO_ID,
  STATUS_EM_EXECUCAO_DESC,
  STATUS_PEDIDO_COLOCADO_ID,
  STATUS_PEDIDO_COLOCADO_DESC
} from "./services/solicitacaoDeOrcamentoRules.js";

const COMPANY_SITE_ID_POWDER = "d97e10ea-c48e-4368-905f-942ad3b98c74";
const COMPANY_SITE_ID_DELTA = "c511a33d-6b85-4cdf-88af-6a221f0eb46d";

export default {
  name: "SolicitacaoDeOrcamentoView",
  mixins: [actionPermissionsMixins],
  components: {
    CartaoListaDeSolicitacoes,
    ModalSolicitacaoDeOrcamento
  },
  data() {
    return {
      carregando: false,
      formularioAberto: false,
      modoFormulario: "create",
      colaboradorStore: useColaboradorStore(),
      usuarioNome: "",
      usuarioGrupoId: null,
      usuarioGrupoNome: "",
      empresaLogadaNome: "",
      orcamentos: [],
      formulario: criarFormularioPadrao(),
      statusOpcoes: [],
      statusDescricaoPorId: {},
      clientes: [],
      clientesCarregando: false,
      buscaClientes: "",
      debounceBuscaClientes: null,
      contatosCliente: [],
      contatosComerciaisCliente: [],
      contatosTecnicosCliente: [],
      abrirNovoContato: false,
      novoContato: {
        nome: "",
        email: "",
        telefone: "",
        celular: ""
      },
      vendedores: [],
      orcamentistas: [],
      tiposDeEquipamento: [],
      propostasTecnicas: [],
      propostasComerciais: [],
      followUps: [],
      revisoes: [],
      dialogCamposFaltantes: false,
      camposFaltantes: [],
      contextoCamposFaltantes: "job",
      salesOrderLegadoService: new EntityService("SalesOrder"),
      tipoEquipamentoService: new EntityService("TipoDeEquipamento"),
      clienteService: new EntityService("Cliente"),
      contatoService: new EntityService("ClienteContatos"),
      statusService: new EntityService("StatusFollowUp"),
      colaboradorService: new EntityService("Collaborator"),
      salesOrderItemService: new EntityService("SalesOrderItem"),
      followUpService: new EntityService("SalesOrderFollowUp"),
      revisoesService: new EntityService("SalesOrderHistoricoRevisao"),
      revisoesLegadoService: new EntityService("Revisoes"),
      jobService: new EntityService("Project"),
      aplicandoCamposItens: false
    };
  },
  computed: {
    podeCriarSolicitacao() {
      return this.validarPermissaoCrud("Create");
    },

    podeEditarSolicitacao() {
      return this.validarPermissaoCrud("Update");
    },

    podeCancelarSolicitacao() {
      return this.validarPermissaoCrud("Delete");
    },

    podeGerarJob() {
      if (!this.validarPermissaoCrud("Update")) return false;
      if (!this.statusOrcamentoConcluido(this.formulario)) return false;
      if (this.formulario.status === STATUS_PEDIDO_COLOCADO_ID) return false;
      if (this.registroPossuiJobAssociado(this.formulario)) return false;
      return true;
    },

    podeConcluirSolicitacao() {
      return this.validarCamposParaGerarJob(false).length === 0;
    },

    camposFaltantesAgrupados() {
      const grupos = {};
      this.camposFaltantes.forEach(({ secao, label }) => {
        if (!grupos[secao]) grupos[secao] = { nome: secao, campos: [] };
        grupos[secao].campos.push({ label });
      });
      return Object.values(grupos);
    }
  },
  methods: {
    isDevAmbiente() {
      return process.env.NODE_ENV !== "production";
    },

    debugSolicitacao(tag = "", dados = null) {
      if (!this.isDevAmbiente()) return;
      if (dados !== null && dados !== undefined) {
        console.debug(`[SolicitacaoDeOrcamento][debug] ${tag}`, dados);
        return;
      }
      console.debug(`[SolicitacaoDeOrcamento][debug] ${tag}`);
    },

    async carregarDadosUsuario() {
      try {
        const params = await authService.getUserParams();
        const usuarioNomeBase =
          params?.user ||
          params?.name ||
          params?.nome ||
          params?.username ||
          "";

        this.usuarioNome = usuarioNomeBase;

        this.usuarioGrupoId = params?.groupId || params?.grupoId || null;
        this.usuarioGrupoNome = params?.groupName || params?.grupo || params?.group || "";

        const empresaLocalStorage = window?.localStorage?.getItem("CompanySiteDescriptionSelected") || "";
        const empresaParams =
          params?.companySiteDescriptionDefault ||
          params?.companySiteDescription ||
          params?.companySiteName ||
          empresaLocalStorage ||
          "";
        this.empresaLogadaNome = String(empresaParams || "").trim();

        this.aplicarOrigemDaEmpresaNoFormulario();

        const nomeColaboradorStore = String(this.colaboradorStore?.colaborador?.nome || "").trim();
        if (nomeColaboradorStore) {
          this.usuarioNome = nomeColaboradorStore;
        } else {
          this.usuarioNome = await this.resolverNomeColaboradorDoUsuario(params, usuarioNomeBase);
        }

        const userId = params?.userId || params?.id || null;
        if (userId && typeof this.getActionsPermission === "function") {
          this.actionsData = [];
          this.actionsList = [];
          this.actionsUser = [];
          this.schemaPermissions = [];
          await this.getActionsPermission(userId);
        }
      } catch (_) {
        this.usuarioNome = "";
        this.usuarioGrupoId = null;
        this.usuarioGrupoNome = "";
        this.empresaLogadaNome = "";
      }
    },

    async resolverNomeColaboradorDoUsuario(params = {}, nomeFallback = "") {
      const nomePadrao = String(nomeFallback || "").trim();
      try {
        const usuario = params?.user || params?.username || params?.email || "";
        const userId = params?.userId || params?.id || "";
        const possiveisCampos = [
          ["user", usuario],
          ["email", params?.email || ""],
          ["userId", userId],
          ["owner", userId]
        ].filter(([, valor]) => Boolean(valor));

        for (const [campo, valor] of possiveisCampos) {
          try {
            const response = await this.colaboradorService.search(campo, valor, 1, 5, null, "Equals", null, "name");
            const lista = this.extrairListaResponse(response);
            const colaborador = Array.isArray(lista) ? lista[0] : null;
            const nome = colaborador?.name || colaborador?.nome || "";
            if (nome) return nome;
          } catch (_) {
            // tenta próximo campo
          }
        }

        return nomePadrao;
      } catch (_) {
        return nomePadrao;
      }
    },

    determinarOrigemPorEmpresa(empresaNome = "") {
      const texto = this.normalizarTextoComparacao(empresaNome);
      if (texto.includes("powder")) return "POWDER";
      return "DELTA DUCON";
    },

    determinarOrigemPorCodigo(codigo = "") {
      const texto = String(codigo || "").trim().toUpperCase();
      if (!texto) return "";
      if (texto.startsWith("P")) return "POWDER";
      if (texto.startsWith("D")) return "DELTA DUCON";
      return "";
    },

    obterPrefixoOrigem() {
      const origem = String(this.formulario?.origem || "").toUpperCase();
      return origem.includes("POWDER") ? "P" : "D";
    },

    aplicarOrigemDaEmpresaNoFormulario() {
      const origem = this.determinarOrigemPorEmpresa(this.empresaLogadaNome);
      this.formulario.origem = origem;
      this.formulario.companySiteId = this.resolverCompanySiteIdPorOrigem(origem);
    },

    resolverCompanySiteIdPorOrigem(origem = "") {
      const textoOrigem = this.normalizarTextoComparacao(origem);
      if (textoOrigem.includes("powder")) return COMPANY_SITE_ID_POWDER;
      return COMPANY_SITE_ID_DELTA;
    },

    normalizarDataParaInput(valor = "") {
      if (!valor) return "";
      const texto = String(valor).trim();
      if (!texto) return "";
      if (/^\d{4}-\d{2}-\d{2}$/.test(texto)) return texto;
      if (/^\d{4}-\d{2}-\d{2}T/.test(texto)) return texto.slice(0, 10);
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(texto)) {
        const [dia, mes, ano] = texto.split("/");
        return `${ano}-${mes}-${dia}`;
      }

      const data = new Date(texto);
      if (Number.isNaN(data.getTime())) return "";

      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate()).padStart(2, "0");
      return `${ano}-${mes}-${dia}`;
    },

    obterStatusConcluido() {
      return (this.statusOpcoes || []).find((item) => {
        const descricao = this.normalizarTextoComparacao(item?.description || item?.descricao || item?.name);
        return descricao === "concluido";
      }) || null;
    },

    statusOrcamentoConcluido(item = {}) {
      const statusConcluido = this.obterStatusConcluido();
      const statusId = typeof item?.status === "object" ? item?.status?.id : item?.status;
      const descricao = this.normalizarTextoComparacao(item?.statusDescription || item?.status?.description || "");
      if (statusConcluido?.id && statusId === statusConcluido.id) return true;
      return descricao === "concluido";
    },

    async concluirSolicitacao() {
      try {
        const statusConcluido = this.obterStatusConcluido();
        if (!statusConcluido) {
          this.$notfy?.error("Status CONCLUÍDO não encontrado nas opções.");
          return;
        }

        this.formulario.status = statusConcluido.id;
        this.formulario.statusDescription = statusConcluido.description;
        await this.salvarOrcamento();
        this.$notfy?.success("Solicitação concluída com sucesso!");
      } catch (_) {
        this.$notfy?.error("Erro ao concluir solicitação.");
      }
    },

    colaboradorPertenceAoGrupoLogado(item = {}) {
      const grupoIdUsuario = this.usuarioGrupoId ? String(this.usuarioGrupoId) : "";
      const grupoNomeUsuario = this.normalizarTextoComparacao(this.usuarioGrupoNome);

      if (!grupoIdUsuario && !grupoNomeUsuario) return true;

      const camposGrupo = [
        item?.group,
        item?.groupId,
        item?.grupo,
        item?.grupoId,
        item?.groupUser,
        item?.groupName
      ];

      const gruposTexto = this.extrairListaTextual(camposGrupo);
      if (!gruposTexto.length) return true;

      if (grupoIdUsuario && gruposTexto.includes(this.normalizarTextoComparacao(grupoIdUsuario))) return true;
      if (grupoNomeUsuario && gruposTexto.includes(grupoNomeUsuario)) return true;
      return false;
    },

    clienteStatusAtivo(item = {}) {
      const status = this.normalizarTextoComparacao(item?.statusDescription || item?.status || item?.situacao || item?.ativo);
      if (!status) return true;
      return ["ativo", "active", "sim", "true", "1"].includes(status);
    },

    clientePossuiCamposObrigatorios(item = {}) {
      return Boolean(
        item?.cnpj &&
        item?.razaoSocial &&
        item?.nomeFantasia &&
        item?.inscricaoEstadual
      );
    },

    contatoClienteValido(item = {}) {
      return Boolean(
        item?.nome &&
        (item?.tipo || item?.type || item?.tipoContato) &&
        (item?.departamento || item?.department || item?.setor) &&
        item?.email &&
        (item?.telefone || item?.celular)
      );
    },

    normalizarCamposFinanceiros() {
      this.recalcularCamposPreco();
      this.normalizarCamposNumericosParaInput();
    },

    validarPermissaoCrud(operacao = "Read") {
      if (typeof this.getPermissionCrud !== "function") return true;

      const possuiPermissoesCarregadas = Array.isArray(this.schemaPermissions) && this.schemaPermissions.length > 0;
      if (!possuiPermissoesCarregadas) return true;

      return ["SalesOrder"].some((schemaName) => (
        Boolean(this.getPermissionCrud({ title: schemaName }, operacao))
      ));
    },

    textoStatusItem(item = {}) {
      return String(item?.statusDescription || item?.status || "").trim().toUpperCase();
    },

    registroCancelado(item = {}) {
      return this.textoStatusItem(item).includes("CANCEL");
    },

    registroPossuiJobAssociado(item = {}) {
      if (item?.job || item?.jobNome || item?.project || item?.projectId) return true;
      return this.textoStatusItem(item).includes("PEDIDO COLOCADO");
    },

    statusSolicitacaoPedidoColocado(item = {}) {
      const textoStatus = this.textoStatusItem(item);
      const statusId = typeof item?.status === "object" ? item?.status?.id : item?.status;
      if (statusId && statusId === STATUS_PEDIDO_COLOCADO_ID) return true;
      return textoStatus.includes("PEDIDO COLOCADO");
    },

    podeAdicionarEditarItensSolicitacao(item = {}) {
      if (this.statusSolicitacaoPedidoColocado(item)) return false;
      return !this.registroCancelado(item);
    },

    podeExcluirItensSolicitacao(item = {}) {
      if (!this.podeAdicionarEditarItensSolicitacao(item)) return false;
      return !this.statusOrcamentoConcluido(item);
    },

    obterStatusPorDescricao(fragmentos = []) {
      const termos = (Array.isArray(fragmentos) ? fragmentos : [fragmentos])
        .map((item) => this.normalizarTextoComparacao(item))
        .filter(Boolean);

      return (this.statusOpcoes || []).find((status) => {
        const descricao = this.normalizarTextoComparacao(status?.description || status?.descricao || status?.name);
        return termos.some((termo) => descricao.includes(termo));
      }) || null;
    },

    extrairNumeroRevisao(valor = "") {
      const numeros = String(valor || "").match(/(\d+)(?!.*\d)/);
      return Number(numeros?.[1] || 0);
    },

    extrairNumeroPropostaBase(codigo = "") {
      const texto = String(codigo || "").trim().toUpperCase();
      if (!texto) return "";
      return texto.replace(/-REV\d{2}$/i, "").replace(/-RV\d{2}$/i, "");
    },

    montarNumeroPropostaComRevisao(numeroPropostaBase = "", revisao = "") {
      const base = this.extrairNumeroPropostaBase(numeroPropostaBase);
      if (!base) return "";

      const numeroRevisao = this.extrairNumeroRevisao(revisao);
      if (!numeroRevisao) return base;

      return `${base}-RV${String(numeroRevisao).padStart(2, "0")}`;
    },

    formatarCodigoRevisao(numero = 0) {
      return `RV${String(Number(numero || 0)).padStart(2, "0")}`;
    },

    normalizarCodigoRevisao(valor = "") {
      const texto = String(valor || "").trim().toUpperCase();
      if (!texto) return "ORIGINAL";
      if (texto === "ORIGINAL") return "ORIGINAL";

      const numero = this.extrairNumeroRevisao(texto);
      if (!numero) return "ORIGINAL";
      return this.formatarCodigoRevisao(numero);
    },

    obterProximaRevisao() {
      const candidatos = [
        this.formulario?.revisao,
        this.formulario?.version,
        this.formulario?.ultimaRevisao,
        ...(Array.isArray(this.revisoes) ? this.revisoes.map((item) => item?.revisao) : [])
      ];

      const maiorRevisao = candidatos.reduce((maior, revisaoAtual) => {
        return Math.max(maior, this.extrairNumeroRevisao(revisaoAtual));
      }, 0);

      return this.formatarCodigoRevisao(maiorRevisao + 1);
    },

    garantirHistoricoMinimoRevisoes(lista = []) {
      const revisoesBase = Array.isArray(lista) ? [...lista] : [];
      const mapaPorRevisao = new Map();

      const pontuar = (item = {}) => {
        let pontos = 0;
        if (item?.dateGenerate) pontos += 4;
        if (item?.statusDescription || item?.status) pontos += 3;
        if (item?._mirror_tipoDeEquipamento || item?.tipoDeEquipamentoDescricao || item?.tipoDeEquipamento) pontos += 2;
        if (item?.numeroProposta) pontos += 1;
        return pontos;
      };

      revisoesBase.forEach((item) => {
        const codigoRevisao = this.normalizarCodigoRevisao(item?.revisao);
        const atual = mapaPorRevisao.get(codigoRevisao);
        if (!atual) {
          mapaPorRevisao.set(codigoRevisao, item);
          return;
        }

        const pontosAtual = pontuar(atual);
        const pontosNovo = pontuar(item);
        if (pontosNovo > pontosAtual) {
          mapaPorRevisao.set(codigoRevisao, item);
          return;
        }

        if (pontosNovo === pontosAtual) {
          const dataAtual = new Date(atual?.dateGenerate || 0).getTime();
          const dataNova = new Date(item?.dateGenerate || 0).getTime();
          if (dataNova > dataAtual) {
            mapaPorRevisao.set(codigoRevisao, item);
          }
        }
      });

      return Array.from(mapaPorRevisao.values()).sort((a, b) => {
        const numeroB = this.extrairNumeroRevisao(b?.revisao);
        const numeroA = this.extrairNumeroRevisao(a?.revisao);
        if (numeroB !== numeroA) return numeroB - numeroA;

        const dataB = new Date(b?.dateGenerate || 0).getTime();
        const dataA = new Date(a?.dateGenerate || 0).getTime();
        return dataB - dataA;
      });
    },

    recalcularCamposPreco() {
      const dadosCalculados = recalcularCamposPreco(this.formulario);
      Object.keys(dadosCalculados).forEach((campo) => {
        this.$set(this.formulario, campo, dadosCalculados[campo]);
      });
    },

    normalizarCamposNumericosParaInput() {
      this.formulario.valorEstimado = formatarNumeroInput(this.formulario.valorEstimado);
      this.formulario.valorDisponivel = formatarNumeroInput(this.formulario.valorDisponivel);
      this.formulario.ki = formatarNumeroInput(this.formulario.ki, 3);
      this.formulario.porcentagemPIS = formatarNumeroInput(this.formulario.porcentagemPIS);
      this.formulario.porcentagemCOFINS = formatarNumeroInput(this.formulario.porcentagemCOFINS);
      this.formulario.porcentagemISS = formatarNumeroInput(this.formulario.porcentagemISS || this.formulario.porcentagemIIS);
      this.formulario.porcentagemIIS = formatarNumeroInput(this.formulario.porcentagemIIS);
      this.formulario.porcentagemICMSVenda = formatarNumeroInput(this.formulario.porcentagemICMSVenda);
      this.formulario.pocentagemIPIVenda = formatarNumeroInput(this.formulario.pocentagemIPIVenda || this.formulario.porcentagemIPI);
      this.formulario.porcentagemIPI = formatarNumeroInput(this.formulario.porcentagemIPI);
      this.formulario.precoVenda_sIPI_cICMS = formatarNumeroInput(this.formulario.precoVenda_sIPI_cICMS);
      this.formulario.precoVenda_cIPI_cICMS = formatarNumeroInput(this.formulario.precoVenda_cIPI_cICMS);
      this.formulario.precoVenda_sIPI_sICMS = formatarNumeroInput(this.formulario.precoVenda_sIPI_sICMS);
      this.formulario.precoVenda_cISS = formatarNumeroInput(this.formulario.precoVenda_cISS);
      this.formulario.kidoCusto = formatarNumeroInput(this.formulario.kidoCusto);
      this.formulario.valorICMS = formatarNumeroInput(this.formulario.valorICMS);
      this.formulario.valorIPI = formatarNumeroInput(this.formulario.valorIPI);
    },

    obterPrimeiroValorComercial(...valores) {
      for (const valor of valores) {
        if (valor !== undefined && valor !== null && valor !== "") return valor;
      }
      return undefined;
    },

    aplicarCamposComerciaisDoSchemaSemItens(base = {}) {
      const itensFormulario = Array.isArray(this.formulario?.itens) ? this.formulario.itens : [];
      if (itensFormulario.length > 0) return;

      const valorDisponivel = this.obterPrimeiroValorComercial(
        this.formulario?.valorDisponivel,
        base?.valorDisponivel,
        base?.revisoes?.valorDisponivel
      );
      if (valorDisponivel !== undefined) this.formulario.valorDisponivel = valorDisponivel;

      const precoVendaSemIpi = this.obterPrimeiroValorComercial(
        this.formulario?.precoVenda_sIPI_cICMS,
        base?.precoVenda_sIPI_cICMS,
        base?._mirror_valor_sIPI_cICMS,
        base?.revisoes?.precoVenda_sIPI_cICMS
      );
      if (precoVendaSemIpi !== undefined) this.formulario.precoVenda_sIPI_cICMS = precoVendaSemIpi;

      const valorICMS = this.obterPrimeiroValorComercial(
        this.formulario?.valorICMS,
        base?.valorICMS,
        base?.revisoes?.valorICMS
      );
      if (valorICMS !== undefined) this.formulario.valorICMS = valorICMS;

      const valorIPI = this.obterPrimeiroValorComercial(
        this.formulario?.valorIPI,
        base?.valorIPI,
        base?.revisoes?.valorIPI
      );
      if (valorIPI !== undefined) this.formulario.valorIPI = valorIPI;

      const precoVendaComIpi = this.obterPrimeiroValorComercial(
        this.formulario?.precoVenda_cIPI_cICMS,
        base?.precoVenda_cIPI_cICMS,
        base?.revisoes?.precoVenda_cIPI_cICMS
      );
      if (precoVendaComIpi !== undefined) this.formulario.precoVenda_cIPI_cICMS = precoVendaComIpi;
    },

    getClienteNomePorId(clienteId) {
      const cliente = this.clientes.find((item) => {
        const itemId = item?.id || item?._id;
        return String(itemId || "") === String(clienteId || "");
      });
      return cliente?.nomeFantasia || cliente?.razaoSocial || cliente?.nome || "";
    },

    getClienteCnpjPorId(clienteId) {
      const cliente = this.clientes.find((item) => {
        const itemId = item?.id || item?._id;
        return String(itemId || "") === String(clienteId || "");
      });

      if (!cliente) return "";

      return (
        cliente?.cnpj ||
        cliente?.cgc ||
        cliente?.cpfCnpj ||
        cliente?._currentData?.cnpj ||
        cliente?._currentData?.cgc ||
        cliente?._currentData?.cpfCnpj ||
        ""
      );
    },

    obterCompanySiteIdDoRegistro(item = {}) {
      const valor =
        item?.companySiteId ||
        item?.companySite ||
        item?.companySiteID ||
        item?.companySite_id ||
        item?.companySiteLegacyId ||
        null;

      if (!valor) return null;
      if (Array.isArray(valor)) return this.obterCompanySiteIdDoRegistro(valor[0] || {});
      if (typeof valor === "object") return valor?.id || valor?._id || null;
      return valor;
    },

    registroEstaDeletado(item = {}) {
      return Boolean(item?.isDeleted || item?.deleted || item?.deleteAt || item?.deletedAt);
    },

    registroCarregavel(item = {}) {
      const id = item?.id || item?._id;
      const codigo = String(item?.code || item?.codigo || item?.numeroSolicitacao || item?.numeroProposta || "").trim();
      return Boolean(id || codigo);
    },

    registroPertenceAoCompanySiteAtivo(item = {}, companySiteIdAtivo = null) {
      if (!companySiteIdAtivo) return true;
      const companySiteRegistro = this.obterCompanySiteIdDoRegistro(item);
      if (!companySiteRegistro) return true;
      return String(companySiteRegistro) === String(companySiteIdAtivo);
    },

    getContatoPorId(contatoId) {
      return this.obterTodosContatosCliente().find((item) => item.id === contatoId) || null;
    },

    getColaboradorNomePorId(colaboradorId) {
      const colaboradores = [...(this.vendedores || []), ...(this.orcamentistas || [])];
      const colaborador = colaboradores.find((item) => item.id === colaboradorId);
      return colaborador?.nome || "";
    },

    async obterUsuarioLogadoId() {
      try {
        const params = await authService.getUserParams();
        return params?.userId || params?.id || null;
      } catch (_) {
        return null;
      }
    },

    async obterColaboradorLogado() {
      try {
        const colaboradorArmazenado = this.colaboradorStore?.colaborador || {};
        const colaboradorArmazenadoId = colaboradorArmazenado?.id || colaboradorArmazenado?._id || null;
        if (colaboradorArmazenadoId) {
          return {
            id: colaboradorArmazenadoId,
            nome: colaboradorArmazenado?.nome || ""
          };
        }

        const params = await authService.getUserParams();
        const usuario = params?.user || params?.username || params?.email || "";
        const userId = params?.userId || params?.id || "";

        if (userId) {
          try {
            const response = await this.colaboradorService.search("user", userId, 1, 1, null, "Equals", "userId", "name");
            const lista = this.extrairListaResponse(response);
            const colaboradorView = Array.isArray(lista) ? lista[0] : null;

            if (colaboradorView?.id || colaboradorView?._id) {
              const colaboradorResolvido = {
                id: colaboradorView?.id || colaboradorView?._id,
                nome: colaboradorView?.name || colaboradorView?.nome || ""
              };

              this.colaboradorStore?.save?.(colaboradorResolvido);
              return colaboradorResolvido;
            }
          } catch (_) {
            // tenta o fallback abaixo
          }
        }

        const possiveisCampos = [
          ["user", usuario],
          ["email", params?.email || ""],
          ["userId", userId],
          ["owner", userId]
        ].filter(([, valor]) => Boolean(valor));

        for (const [campo, valor] of possiveisCampos) {
          try {
            const response = await this.colaboradorService.search(campo, valor, 1, 5, null, "Equals", null, "name");
            const lista = this.extrairListaResponse(response);
            const colaborador = Array.isArray(lista) ? lista[0] : null;
            if (colaborador?.id || colaborador?._id) {
              const colaboradorResolvido = {
                id: colaborador?.id || colaborador?._id,
                nome: colaborador?.name || colaborador?.nome || ""
              };

              this.colaboradorStore?.save?.(colaboradorResolvido);
              return {
                id: colaboradorResolvido.id,
                nome: colaboradorResolvido.nome
              };
            }
          } catch (_) {
            // tenta próximo campo
          }
        }

        return null;
      } catch (_) {
        return null;
      }
    },

    async obterCompanySiteIdAtivo() {
      try {
        const local = window?.localStorage?.getItem("CompanySiteIdSelected");
        if (local) return local;

        const params = await authService.getUserParams();
        return params?.companySiteIdDefault || null;
      } catch (_) {
        return null;
      }
    },

    obterRegistroResponse(response) {
      return response?.data?.data || response?.data || null;
    },

    obterIdRegistro(item = null) {
      if (!item) return null;
      return item.id || item._id || null;
    },

    obterCodigoJob(job = null) {
      if (!job) return "";
      return job.code || job.codigo || job.jobCode || "";
    },

    obterIdJob(job = null) {
      if (!job) return null;
      if (Array.isArray(job)) return this.obterIdJob(job[0]);
      if (typeof job === "object") return this.obterIdRegistro(job) || job.code || null;
      return job;
    },

    aplicarJobNoFormulario(job = null) {
      this.formulario.job = this.obterIdJob(job);
      this.formulario.jobNome = this.obterCodigoJob(job);
    },

    async carregarJobRelacionado(solicitacaoId, dadosBase = {}) {
      const jobInformado =
        dadosBase?.job ||
        dadosBase?.project ||
        dadosBase?.jobId ||
        dadosBase?.projectId ||
        null;

      const jobId = this.obterIdJob(jobInformado);
      if (jobId) {
        try {
          const response = await this.jobService.getById(jobId);
          const job = this.obterRegistroResponse(response) || jobInformado;
          this.aplicarJobNoFormulario(job);
          return job;
        } catch (error) {
          this.aplicarJobNoFormulario(jobInformado);
          return jobInformado;
        }
      }

      if (!solicitacaoId) {
        this.aplicarJobNoFormulario(null);
        return null;
      }

      const codigoSolicitacao =
        dadosBase?.numeroProposta ||
        dadosBase?.numeroSolicitacao ||
        dadosBase?.codigo ||
        dadosBase?.code ||
        this.formulario?.numeroProposta ||
        this.formulario?.numeroSolicitacao ||
        this.formulario?.codigo ||
        this.formulario?.code ||
        "";

      const buscas = [
        { campo: "salesOrder", valor: solicitacaoId },
        { campo: "salesOrderId", valor: solicitacaoId },
        { campo: "salesOrderCode", valor: codigoSolicitacao },
        { campo: "solicitacaoDeOrcamentoCodigo", valor: codigoSolicitacao }
      ].filter((item) => Boolean(item.valor));

      for (const busca of buscas) {
        const resposta = await this.jobService.search(busca.campo, busca.valor, 1, 10, null, "Equals");
        const lista = this.extrairListaResponse(resposta);
        if (Array.isArray(lista) && lista.length > 0) {
          const job = lista[0];
          this.aplicarJobNoFormulario(job);
          return job;
        }
      }

      this.aplicarJobNoFormulario(null);
      return null;
    },

    preencherContatoNoFormulario(contato = null) {
      this.formulario.contato = contato?.id || null;
      this.formulario.contatoComercial = contato?.id || null;
      this.formulario.contatoNome = contato?.nome || "";
      this.formulario.contatoComercialNome = contato?.nome || "";
      this.formulario.email = contato?.email || "";
      this.formulario.telefone = contato?.telefone || contato?.celular || "";
      this.formulario.contatoComercialTelefone = contato?.telefone || "";
      this.formulario.contatoComercialCelular = contato?.celular || "";
      this.formulario.contatoComercialEmail = contato?.email || "";
    },

    preencherContatoTecnicoNoFormulario(contato = null) {
      this.formulario.contatoTecnico = contato?.id || null;
      this.formulario.contatoTecnicoNome = contato?.nome || "";
      this.formulario.contatoTecnicoTelefone = contato?.telefone || "";
      this.formulario.contatoTecnicoCelular = contato?.celular || "";
      this.formulario.contatoTecnicoEmail = contato?.email || "";
    },

    obterTodosContatosCliente() {
      const mapa = new Map();
      [...(this.contatosCliente || []), ...(this.contatosComerciaisCliente || []), ...(this.contatosTecnicosCliente || [])]
        .filter(Boolean)
        .forEach((item) => {
          const chave = item?.id || item?._id || item?.nome;
          if (chave && !mapa.has(chave)) mapa.set(chave, item);
        });
      return Array.from(mapa.values());
    },

    valorBooleanoVerdadeiro(valor = null) {
      const texto = this.normalizarTextoComparacao(valor);
      return ["sim", "true", "1", "yes", "y", "ativo"].includes(texto);
    },

    extrairListaTextual(valor = null) {
      if (Array.isArray(valor)) return valor.flatMap((item) => this.extrairListaTextual(item));
      if (valor && typeof valor === "object") return Object.values(valor).flatMap((item) => this.extrairListaTextual(item));
      if (valor === null || valor === undefined) return [];
      return String(valor)
        .split(/[;,|]/)
        .map((item) => this.normalizarTextoComparacao(item))
        .filter(Boolean);
    },

    colaboradorEhVendedor(item = {}) {
      const gruposPermitidos = [
        "Comercial Vendedores",
        "ATS",
        "Comercial - Gestão",
        "Comercial Sobressalentes - Supervisor",
        "Fabrica Almoxarifado - Supervisão",
        "Fabrica Almoxarifado - Supervisão"
      ].map((itemGrupo) => this.normalizarTextoComparacao(itemGrupo));

      const gruposDoColaborador = this.extrairListaTextual(item?.grupo || item?.group || item?.grupoNome || item?.grupoDescricao);
      const grupoPermitido = gruposDoColaborador.some((grupo) => gruposPermitidos.includes(grupo));

      const statusNormalizado = this.normalizarTextoComparacao(
        item?.statusDescription ||
        item?.status?.description ||
        item?.status ||
        item?.situacao ||
        item?.ativo
      );

      return grupoPermitido && (!statusNormalizado || statusNormalizado === "ativo");
    },

    colaboradorEhOrcamentista(item = {}) {
      const gruposPermitidos = [
        "Engenharia Aplicação - Operação",
        "Engenharia Aplicação - Supervisor",
        "Comercial Sobressalentes - Operação",
        "Comercial Sobressalentes - Supervisor",
        "Fabrica Almoxarifado - Supervisão"
      ].map((itemGrupo) => this.normalizarTextoComparacao(itemGrupo));

      const gruposDoColaborador = this.extrairListaTextual(item?.grupo || item?.group || item?.grupoNome || item?.grupoDescricao);
      const grupoPermitido = gruposDoColaborador.some((grupo) => gruposPermitidos.includes(grupo));

      const statusNormalizado = this.normalizarTextoComparacao(
        item?.statusDescription ||
        item?.status?.description ||
        item?.status ||
        item?.situacao ||
        item?.ativo
      );

      return grupoPermitido && (!statusNormalizado || statusNormalizado === "ativo");
    },

    obterTipoContatoNormalizado(item = {}) {
      return this.normalizarTextoComparacao(
        item?.tipo ||
        item?.type ||
        item?.tipoContato ||
        item?.contatoTipo ||
        item?.categoria ||
        item?.classificacao ||
        item?.departamento
      );
    },

    contatoEhComercial(item = {}) {
      const tipo = this.obterTipoContatoNormalizado(item);
      if (!tipo) return false;
      return tipo.includes("comercial");
    },

    contatoEhTecnico(item = {}) {
      const tipo = this.obterTipoContatoNormalizado(item);
      if (!tipo) return false;
      return tipo.includes("tecnico") || tipo.includes("técnico");
    },

    sincronizarCamposSchemaFormulario() {
      // Não sobrescreve descrição do projeto ao sincronizar campos
      const dataDesejada = this.formulario.dataDesejada || this.formulario.dataDespacho || "";
      const tipoDeOrcamento = this.formulario.tipoDeOrcamento || this.formulario.tipoFaturamento || null;
      const porcentagemISS = this.formulario.porcentagemISS || this.formulario.porcentagemIIS || "0,00";
      const porcentagemIPI = this.formulario.pocentagemIPIVenda || this.formulario.porcentagemIPI || "0,00";

      this.formulario.dataDesejada = dataDesejada;
      this.formulario.dataDespacho = dataDesejada;
      this.formulario.tipoDeOrcamento = tipoDeOrcamento;
      this.formulario.tipoFaturamento = tipoDeOrcamento;
      this.formulario.porcentagemISS = porcentagemISS;
      this.formulario.porcentagemIIS = porcentagemISS;
      this.formulario.pocentagemIPIVenda = porcentagemIPI;
      this.formulario.porcentagemIPI = porcentagemIPI;
    },

    async carregarStatus() {
      try {
        const response = await this.statusService.getAll(1, 1000, "", "", null, null, null, "description");
        const lista = response?.data?.data?.data || response?.data?.data || response?.data || [];
        this.statusOpcoes = Array.isArray(lista) ? lista : [];
        this.statusDescricaoPorId = this.statusOpcoes.reduce((acc, status) => {
          if (status?.id) acc[status.id] = status?.description || "Sem status";
          return acc;
        }, {});
      } catch (error) {
        this.statusOpcoes = [];
        this.statusDescricaoPorId = {};
      }
    },

    async carregarClientes(termoBusca = "") {
      try {
        this.clientesCarregando = true;

        const termo = String(termoBusca || "").trim();
        let lista = [];

        if (!termo) {
          const response = await this.clienteService.getAll(1, 50, "", "", null, null, null, "nomeFantasia");
          lista = this.extrairListaResponse(response);
        } else {
          const [porNomeFantasia, porRazaoSocial, porCodigo] = await Promise.allSettled([
            this.clienteService.search("nomeFantasia", termo, 1, 50, null, "Contains", null, "nomeFantasia"),
            this.clienteService.search("razaoSocial", termo, 1, 50, null, "Contains", null, "nomeFantasia"),
            this.clienteService.search("code", termo, 1, 50, null, "Contains", null, "nomeFantasia")
          ]);

          const listasEncontradas = [porNomeFantasia, porRazaoSocial, porCodigo]
            .filter((resultado) => resultado.status === "fulfilled")
            .flatMap((resultado) => this.extrairListaResponse(resultado.value));

          const mapa = new Map();
          listasEncontradas.forEach((item) => {
            const id = item?.id || item?._id;
            if (id) mapa.set(id, item);
          });
          lista = Array.from(mapa.values());
        }

        const clienteSelecionadoId = this.formulario?.cliente;
        const listaNormalizada = Array.isArray(lista) ? lista : [];
        const jaTemSelecionado = listaNormalizada.some((item) => (item?.id || item?._id) === clienteSelecionadoId);

        if (clienteSelecionadoId && !jaTemSelecionado) {
          try {
            const responseCliente = await this.clienteService.getById(clienteSelecionadoId);
            const clienteSelecionado = this.obterRegistroResponse(responseCliente);
            if (clienteSelecionado?.id || clienteSelecionado?._id) {
              listaNormalizada.unshift(clienteSelecionado);
            }
          } catch (_) {
            // sem ação
          }
        }

        this.clientes = listaNormalizada
          .filter((item) => item && typeof item === "object")
          .map((item) => ({
            ...item,
            id: item?.id || item?._id || null,
            _id: item?._id || item?.id || null
          }))
          .filter((item) => Boolean(item?.id || item?._id));
      } catch (error) {
        this.clientes = [];
      } finally {
        this.clientesCarregando = false;
      }
    },

    aoBuscarClientes(termoBusca = "") {
      this.buscaClientes = String(termoBusca || "");
      if (this.debounceBuscaClientes) {
        clearTimeout(this.debounceBuscaClientes);
      }

      this.debounceBuscaClientes = setTimeout(() => {
        this.carregarClientes(this.buscaClientes);
      }, 300);
    },

    async carregarColaboradores() {
      try {
        const responseTodos = await this.colaboradorService.getAll(1, 1000, "", "", null, null, null, "name");

        const listaTodos = responseTodos?.data?.data?.data || responseTodos?.data?.data || responseTodos?.data || [];

        const listaVendedores = (Array.isArray(listaTodos) ? listaTodos : [])
          .filter((item) => this.colaboradorEhVendedor(item));

        const listaOrcamentistas = (Array.isArray(listaTodos) ? listaTodos : [])
          .filter((item) => this.colaboradorEhOrcamentista(item));

        const mapear = (item) => ({
          ...item,
          id: item.id || item._id,
          nome: item.name || item.nome || ""
        });

        const vendedoresFiltrados = Array.isArray(listaVendedores) ? listaVendedores : [];

        const orcamentistasFiltrados = Array.isArray(listaOrcamentistas) ? listaOrcamentistas : [];

        this.vendedores = vendedoresFiltrados.map(mapear);
        this.orcamentistas = orcamentistasFiltrados.map(mapear);
      } catch (error) {
        this.vendedores = [];
        this.orcamentistas = [];
      }
    },

    async carregarTiposDeEquipamento() {
      try {
        const response = await this.tipoEquipamentoService.getAll(1, 500, "", "", null, null, null, "descricao");
        const lista = response?.data?.data?.data || response?.data?.data || response?.data || [];
        this.tiposDeEquipamento = Array.isArray(lista) ? lista : [];
      } catch (error) {
        this.tiposDeEquipamento = [];
      }
    },

    getTipoEquipamentoById(id) {
      if (!id) return null;
      return this.tiposDeEquipamento.find((t) => t.id === id) || null;
    },

    valorPareceGuid(valor = "") {
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(String(valor || "").trim());
    },

    resolverDadosTipoEquipamento(base = {}) {
      const mirrorRaw = base?._mirror_tipoDeEquipamento;
      const tipoRaw =
        base?.tipoDeEquipamento ||
        (typeof mirrorRaw === "string" && this.getTipoEquipamentoById(mirrorRaw)
          ? mirrorRaw
          : null);
      const tipoId = typeof tipoRaw === "object" ? tipoRaw?.id : tipoRaw || null;
      const tipoObj = this.getTipoEquipamentoById(tipoId) || (typeof tipoRaw === "object" ? tipoRaw : null);
      const mirrorTexto =
        typeof mirrorRaw === "string" &&
        !this.getTipoEquipamentoById(mirrorRaw) &&
        !this.valorPareceGuid(mirrorRaw)
          ? mirrorRaw
          : "";

      return {
        tipoId,
        tipoObj,
        tipoSigla:
          tipoObj?.sigla ||
          tipoObj?.codigo ||
          tipoObj?.code ||
          base?.tipoDeEquipamentoSigla ||
          "",
        tipoDescricao:
          tipoObj?.descricao ||
          tipoObj?.nome ||
          tipoObj?.description ||
          tipoObj?.name ||
          base?.tipoDeEquipamentoDescricao ||
          mirrorTexto ||
          ""
      };
    },

    sanitizarPayloadSalesOrder(payload = {}) {
      const camposPermitidosSalesOrder = new Set([
        "id",
        "liberar",
        "codigo",
        "companySiteId",
        "status",
        "statusDescription",
        "job",
        "ultimaRevisao",
        "version",
        "tipoDeOrcamento",
        "_mirror_tipo",
        "dateGenerate",
        "tipoDeEquipamento",
        "tipoDeEquipamentoSigla",
        "tipoDeEquipamentoDescricao",
        "_mirror_tipoDeEquipamento",
        "_mirror_valor_sIPI_cICMS",
        "_mirror_projeto",
        "_mirror_dataSolicitacao",
        "_mirror_dataDesejada",
        "_mirror_dataConclusao",
        "cliente",
        "clienteNome",
        "cliente_referencia",
        "vendedor",
        "vendedorNome",
        "orcamentista",
        "orcamentistaNome",
        "contatoComercial",
        "contatoComercialNome",
        "contatoComercialTelefone",
        "contatoComercialCelular",
        "contatoComercialEmail",
        "contatoTecnico",
        "contatoTecnicoNome",
        "contatoTecnicoTelefone",
        "contatoTecnicoCelular",
        "contatoTecnicoEmail",
        "owners",
        "projetoDescricao",
        "observacao",
        "dataSolicitacao",
        "dataDesejada",
        "dataConclusao",
        "valorDisponivel",
        "porcentagemPIS",
        "porcentagemCOFINS",
        "ki",
        "kidoCusto",
        "porcentagemISS",
        "porcentagemICMSVenda",
        "pocentagemIPIVenda",
        "precoVenda_sIPI_cICMS",
        "precoVenda_cIPI_cICMS",
        "precoVenda_sIPI_sICMS",
        "precoVenda_cISS",
        "kv",
        "followUp",
        "revisoes",
        "Itens",
        "valorICMS",
        "valorIPI"
      ]);

      const payloadSanitizado = { ...payload };

      if (Array.isArray(payloadSanitizado.itens) && !Array.isArray(payloadSanitizado.Itens)) {
        payloadSanitizado.Itens = payloadSanitizado.itens.map((item) => this.sanitizarItemPayloadSalesOrder(item));
      }

      delete payloadSanitizado.itens;

      if (Array.isArray(payloadSanitizado.Itens)) {
        payloadSanitizado.Itens = payloadSanitizado.Itens
          .map((item) => (typeof item === "string" ? item : this.obterIdRegistro(item)))
          .filter(Boolean);
      }

      [
        "code",
        "numeroProposta",
        "numeroSolicitacao",
        "origem",
        "dataCriacao",
        "tipoFaturamento",
        "contabilizar",
        "contato",
        "contatoNome",
        "email",
        "telefone",
        "descricao",
        "prazoResposta",
        "valorEstimado",
        "porcentagemIIS",
        "porcentagemIPI",
        "projeto",
        "dataDespacho",
        "sigla",
        "jobNome",
        "origemSchema",
        "_listKey",
        "createAt",
        "createBy",
        "updateAt",
        "updateBy",
        "deleteAt",
        "deleteBy",
        "isDeleted"
      ].forEach((campo) => delete payloadSanitizado[campo]);

      delete payloadSanitizado.revisao;
      delete payloadSanitizado.revisoesComerciais;

      Object.keys(payloadSanitizado).forEach((chave) => {
        if (!camposPermitidosSalesOrder.has(chave) || payloadSanitizado[chave] === undefined) {
          delete payloadSanitizado[chave];
        }
      });

      if (!payloadSanitizado.job) delete payloadSanitizado.job;
      if (!payloadSanitizado.tipoDeOrcamento) delete payloadSanitizado.tipoDeOrcamento;
      if (!payloadSanitizado.contatoComercial) delete payloadSanitizado.contatoComercial;
      if (!payloadSanitizado.contatoTecnico) delete payloadSanitizado.contatoTecnico;
      if (!payloadSanitizado.companySiteId) delete payloadSanitizado.companySiteId;
      if (!payloadSanitizado.owners) delete payloadSanitizado.owners;
      if (!payloadSanitizado.ultimaRevisao) delete payloadSanitizado.ultimaRevisao;
      if (!payloadSanitizado.version) delete payloadSanitizado.version;

      [
        "dataDesejada",
        "dataConclusao",
        "_mirror_dataDesejada",
        "_mirror_dataConclusao"
      ].forEach((campo) => {
        if (!payloadSanitizado[campo]) {
          delete payloadSanitizado[campo];
        }
      });

      if (!payloadSanitizado._mirror_tipo && payloadSanitizado.tipoDeEquipamentoSigla) {
        payloadSanitizado._mirror_tipo = payloadSanitizado.tipoDeEquipamentoSigla;
      }

      return payloadSanitizado;
    },

    sanitizarItemPayloadSalesOrder(item = {}) {
      const payloadItem = {
        itemId: item.itemId || item.item || null,
        description: String(item.description || item.descricao || "").trim(),
        qty: parseNumero(item.qty ?? item.quantidade),
        unidade: item.unidade || "",
        dtPrev: item.dtPrev || "",
        obs: item.obs || item.observacao || "",
        valorDisponivel: parseNumero(item.valorDisponivel),
        valorDisponivelTotal: parseNumero(
          item.valorDisponivelTotal ||
          (parseNumero(item.qty ?? item.quantidade) * parseNumero(item.valorDisponivel))
        ),
        porcentagemPIS: parseNumero(item.porcentagemPIS),
        porcentagemCOFINS: parseNumero(item.porcentagemCOFINS),
        ki: parseNumero(item.ki),
        kidoCusto: parseNumero(item.kidoCusto),
        porcentagemISS: parseNumero(item.porcentagemISS || item.porcentagemIIS),
        porcentagemICMSVenda: parseNumero(item.porcentagemICMSVenda),
        pocentagemIPIVenda: parseNumero(item.pocentagemIPIVenda || item.porcentagemIPI),
        precoVenda_sIPI_cICMS: parseNumero(item.precoVenda_sIPI_cICMS),
        precoVenda_cIPI_cICMS: parseNumero(item.precoVenda_cIPI_cICMS),
        valorICMS: parseNumero(item.valorICMS),
        valorIPI: parseNumero(item.valorIPI),
        precoVenda_sIPI_sICMS: parseNumero(item.precoVenda_sIPI_sICMS),
        precoVenda_cISS: parseNumero(item.precoVenda_cISS),
        kv: parseNumero(item.kv),
        vlrTotal: parseNumero(item.vlrTotal || item.valorTotal)
      };

      const itemId = this.obterIdRegistro(item);
      if (itemId) payloadItem.id = itemId;

      return payloadItem;
    },

    async persistirItensSalesOrder(itens = []) {
      const lista = Array.isArray(itens) ? itens : [];
      if (!lista.length) return [];

      const idsItens = [];
      for (const item of lista) {
        const payloadItem = this.sanitizarItemPayloadSalesOrder(item);
        const responseItem = await this.salesOrderItemService.insertOrUpdate(payloadItem);
        const itemPersistido = this.obterRegistroResponse(responseItem) || payloadItem;
        const idItem = this.obterIdRegistro(itemPersistido) || payloadItem.id || this.obterIdRegistro(item);
        if (idItem) idsItens.push(idItem);
      }

      return [...new Set(idsItens)];
    },

    obterDescricaoTipoEquipamento(valor = null) {
      if (!valor) return "";

      if (typeof valor === "object") {
        return valor?.descricao || valor?.nome || valor?.description || valor?.name || valor?.sigla || valor?.codigo || valor?.code || "";
      }

      const tipo = this.getTipoEquipamentoById(valor);
      if (tipo) {
        return tipo?.descricao || tipo?.nome || tipo?.description || tipo?.name || tipo?.sigla || tipo?.codigo || tipo?.code || "";
      }

      return String(valor || "");
    },

    tipoEquipamentoSelecionadoEhValido() {
      const tipoId = this.formulario?.tipoDeEquipamento;
      if (!tipoId) return false;

      const tipo = this.getTipoEquipamentoById(tipoId);
      if (!tipo) return false;

      const sigla = String(this.obterSiglaTipoEquipamento(tipo) || "").toUpperCase();
      const origem = String(this.formulario?.origem || "").toUpperCase();
      const prefixoEsperado = origem.includes("POWDER") ? "P" : "D";

      return Boolean(sigla) && sigla.startsWith(prefixoEsperado);
    },

    extrairRevisaoDeCodigoHistorico(codigo = "") {
      const texto = String(codigo || "").toUpperCase();
      if (!texto) return "";

      const match = texto.match(/-(ORIGINAL|RV\d+|REV\d+)(?:-\d+)?$/);
      return match?.[1] || "";
    },

    parseSnapshotRevisao(item = {}) {
      const snapshotRaw = item?.snapshot;
      if (!snapshotRaw || typeof snapshotRaw !== "string") return {};

      try {
        const snapshot = JSON.parse(snapshotRaw);
        return typeof snapshot === "object" && snapshot !== null ? snapshot : {};
      } catch (_) {
        return {};
      }
    },

    normalizarTextoComparacao(valor = "") {
      return String(valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase();
    },

    resolverStatusId(statusValor = null, statusDescricao = "") {
      const lista = Array.isArray(this.statusOpcoes) ? this.statusOpcoes : [];
      if (!lista.length) return null;

      const statusId = typeof statusValor === "object" ? statusValor?.id : statusValor;
      const statusIdEncontrado = lista.find((item) => item?.id === statusId);
      if (statusIdEncontrado?.id) return statusIdEncontrado.id;

      const descricaoComparacao = this.normalizarTextoComparacao(
        statusDescricao || statusValor?.description || statusValor
      );
      if (!descricaoComparacao) return null;

      const statusPorDescricao = lista.find((item) => {
        const descricaoItem = this.normalizarTextoComparacao(item?.description || item?.descricao || item?.name);
        return descricaoItem === descricaoComparacao;
      });

      return statusPorDescricao?.id || null;
    },

    resolverContatoId(contatoValor = null, contatoNome = "") {
      const lista = Array.isArray(this.contatosCliente) ? this.contatosCliente : [];
      if (!lista.length) return null;

      const contatoId = typeof contatoValor === "object" ? contatoValor?.id : contatoValor;
      const contatoPorId = lista.find((item) => item?.id === contatoId);
      if (contatoPorId?.id) return contatoPorId.id;

      const nomeComparacao = this.normalizarTextoComparacao(
        contatoNome || contatoValor?.nome || contatoValor
      );
      if (!nomeComparacao) return null;

      const contatoPorNome = lista.find((item) => {
        const nomeItem = this.normalizarTextoComparacao(item?.nome || item?.name);
        return nomeItem === nomeComparacao;
      });

      return contatoPorNome?.id || null;
    },

    debugSalvarOrcamento(etapa = "", dados = null) {
      try {
        if (dados !== null && dados !== undefined) {
          console.log(`[SolicitacaoDeOrcamento][salvar] ${etapa}`, dados);
          return;
        }
        console.log(`[SolicitacaoDeOrcamento][salvar] ${etapa}`);
      } catch (_) {
        // noop
      }
    },

    sincronizarContatosDoFormulario() {
      const contatoComercialId = this.resolverContatoId(
        this.formulario.contato,
        this.formulario.contatoNome || this.formulario.contatoComercialNome
      );
      const contatoTecnicoId = this.resolverContatoId(
        this.formulario.contatoTecnico,
        this.formulario.contatoTecnicoNome
      );

      if (contatoComercialId) {
        this.selecionarContato(contatoComercialId);
      } else {
        this.formulario.contato = null;
      }

      if (contatoTecnicoId) {
        this.selecionarContatoTecnico(contatoTecnicoId);
      } else {
        this.formulario.contatoTecnico = null;
      }
    },

    obterSiglaTipoEquipamento(tipo = {}) {
      const siglaBase = tipo?.sigla || tipo?.codigo || tipo?.code || "";
      const prefixoOrigem = this.obterPrefixoOrigem();
      if (siglaBase) {
        const sigla = String(siglaBase).trim().toUpperCase().slice(0, 3);
        if (!sigla) return "";
        return `${prefixoOrigem}${sigla.slice(1)}`;
      }

      const descricaoBase = tipo?.descricao || tipo?.nome || tipo?.description || tipo?.name || "";
      const siglaDescricao = String(descricaoBase).replace(/\s+/g, "").toUpperCase().slice(0, 3);
      if (!siglaDescricao) return "";
      return `${prefixoOrigem}${siglaDescricao.slice(1)}`;
    },

    obterSequenciaOrcamento(item = {}) {
      const referencia = item?.code || item?.numeroSolicitacao || item?.numeroProposta || "";
      const numeros = String(referencia).replace(/\D/g, "");
      if (!numeros) return "";
      return numeros.padStart(Math.max(6, numeros.length), "0");
    },

    obterProximaSequenciaPorSigla(sigla = "") {
      const prefixo = String(sigla || "").toUpperCase().slice(0, 3);
      if (!prefixo) return "000001";

      const lista = Array.isArray(this.orcamentos) ? this.orcamentos : [];
      const maior = lista.reduce((acumulado, item) => {
        const codigo = String(item?.numeroProposta || item?.numeroSolicitacao || item?.code || "").toUpperCase();
        if (!codigo.startsWith(`${prefixo}-`)) return acumulado;

        const numero = Number(codigo.replace(/\D/g, ""));
        if (!Number.isFinite(numero)) return acumulado;
        return Math.max(acumulado, numero);
      }, 0);

      return String(maior + 1).padStart(6, "0");
    },

    gerarNumeroProposta(item = {}, siglaOverride = "") {
      const sigla = String(siglaOverride || item?.tipoDeEquipamentoSigla || "").toUpperCase().slice(0, 3);
      let sequencia = this.obterSequenciaOrcamento(item);
      if (!sequencia && !item?.id && sigla) {
        sequencia = this.obterProximaSequenciaPorSigla(sigla);
      }

      if (!sigla && !sequencia) return item?.numeroProposta || "";
      if (!sigla) return sequencia;
      if (!sequencia) return sigla;
      return `${sigla}-${sequencia}`;
    },

    atualizarNumeroPropostaComSiglaAtual(sigla = "") {
      const siglaAtual = String(sigla || this.formulario?.tipoDeEquipamentoSigla || "").trim().toUpperCase().slice(0, 3);
      if (!siglaAtual) return;

      const referenciaAtual =
        this.formulario?.numeroProposta ||
        this.formulario?.codigo ||
        this.formulario?.code ||
        this.formulario?.numeroSolicitacao ||
        "";

      if (!referenciaAtual) return;

      const baseSemRevisao = this.extrairNumeroPropostaBase(referenciaAtual);
      const sufixoSemSigla = String(baseSemRevisao || "").replace(/^[A-Z]{1,3}-/i, "");
      if (!sufixoSemSigla) return;

      const novaBase = `${siglaAtual}-${sufixoSemSigla}`;
      const revisaoAtual = this.formulario?.ultimaRevisao || this.formulario?.revisao || "";
      const numeroAtualizado = this.montarNumeroPropostaComRevisao(novaBase, revisaoAtual) || novaBase;

      this.formulario.numeroProposta = numeroAtualizado;
      this.formulario.codigo = numeroAtualizado;
      this.formulario.code = numeroAtualizado;
      this.formulario.numeroSolicitacao = numeroAtualizado;
    },

    async gerarNumeroPropostaPorSequenciaSchema(schemaName = "SalesOrder", sigla = "") {
      const resposta = await this.salesOrderLegadoService.autoInc(schemaName, "codigo", "######");
      const bruto = resposta?.data?.data || resposta?.data || "";
      const texto = String(bruto || "").trim().toUpperCase();

      if (!texto) {
        throw new Error("Falha ao obter sequência automática de código");
      }

      if (texto.includes("-")) return texto;

      const prefixo = String(sigla || "").trim().toUpperCase().slice(0, 3);
      const numeros = texto.replace(/\D/g, "");
      const sequencia = (numeros || texto).padStart(6, "0");

      if (!prefixo) return sequencia;
      return `${prefixo}-${sequencia}`;
    },

    async gerarCodigoJobPorSequenciaSchema() {
      const resposta = await this.jobService.autoInc("Project", "code", "##-#####");
      const bruto = resposta?.data?.data || resposta?.data || "";
      const texto = String(bruto || "").trim().toUpperCase();

      if (!texto) {
        throw new Error("Falha ao obter sequência automática de código do Job");
      }

      if (/^\d{2}-\d{5}$/.test(texto)) return texto;

      const numeros = texto.replace(/\D/g, "");
      const anoAtual = String(new Date().getFullYear()).slice(-2);

      if (numeros.length >= 7) {
        const ano = numeros.slice(-7, -5);
        const seq = numeros.slice(-5);
        return `${ano}-${seq}`;
      }

      if (numeros.length >= 5) {
        const seq = numeros.slice(-5).padStart(5, "0");
        return `${anoAtual}-${seq}`;
      }

      return `${anoAtual}-${String(texto).replace(/\D/g, "").padStart(5, "0")}`;
    },

    alterarEmpresa(empresa) {
      this.formulario.origem = empresa || this.formulario.origem;
      this.formulario.companySiteId = this.resolverCompanySiteIdPorOrigem(this.formulario.origem);

      // Ao trocar empresa, força nova seleção de tipo para evitar salvar com tipo incompatível
      this.formulario.tipoDeEquipamento = null;
      this.formulario.tipoDeEquipamentoSigla = "";
      this.formulario.tipoDeEquipamentoDescricao = "";
      this.formulario._mirror_tipoDeEquipamento = "";
    },

    selecionarTipoEquipamento(tipoId) {
      const tipo = this.getTipoEquipamentoById(tipoId);
      const siglaTipo = this.obterSiglaTipoEquipamento(tipo);
      const descricaoTipo = tipo?.descricao || tipo?.nome || tipo?.description || tipo?.name || "";

      this.formulario.tipoDeEquipamento = tipoId || null;
      this.formulario.tipoDeEquipamentoSigla = siglaTipo;
      this.formulario.tipoDeEquipamentoDescricao = descricaoTipo;
      this.formulario._mirror_tipoDeEquipamento = tipo || "";

      if (siglaTipo) {
        this.atualizarNumeroPropostaComSiglaAtual(siglaTipo);
      }
    },

    extrairListaResponse(response) {
      return response?.data?.data?.data || response?.data?.data || response?.data || [];
    },

    obterChaveListaOrcamento(item = {}, origemSchema = "") {
      const id = item?.id || item?._id || item?.code || item?.numeroSolicitacao || "sem-id";
      const schema = origemSchema || item?.origemSchema || "desconhecido";
      return `${schema}:${id}`;
    },

    obterChaveDuplicidadeOrcamento(item = {}) {
      return String(item?.numeroProposta || item?.numeroSolicitacao || item?.code || "").trim();
    },

    ordenarOrcamentosLista(lista = []) {
      const obterNumeroOrdenacao = (item = {}) => {
        const textoBase = String(this.extrairNumeroPropostaBase(item?.numeroProposta || item?.numeroSolicitacao || item?.code || ""));
        const numeros = textoBase.replace(/\D/g, "");
        return Number(numeros || 0);
      };

      return [...(Array.isArray(lista) ? lista : [])].sort((a, b) => {
        const numeroB = obterNumeroOrdenacao(b);
        const numeroA = obterNumeroOrdenacao(a);
        if (numeroB !== numeroA) return numeroB - numeroA;

        const dataB = new Date(b?.dateGenerate || b?.dataSolicitacao || b?.createdAt || 0).getTime();
        const dataA = new Date(a?.dateGenerate || a?.dataSolicitacao || a?.createdAt || 0).getTime();
        return dataB - dataA;
      });
    },

    atualizarOrcamentoNaLista(item = {}, origemSchema = "SalesOrder") {
      if (!item) return;

      const normalizado = {
        ...normalizaListaSalesOrder({ data: [item] }, this.statusDescricaoPorId)[0],
        origemSchema
      };

      if (!normalizado?.id) return;

      normalizado._listKey = this.obterChaveListaOrcamento(normalizado, origemSchema);

      // Chave de negócio para identificar todos os registros relacionados (ex: número de proposta)
      const chaveNegocio = String(
        normalizado.numeroProposta || normalizado.numeroSolicitacao || normalizado.code || normalizado.codigo || ""
      ).trim();

      let listaAtual = Array.isArray(this.orcamentos) ? [...this.orcamentos] : [];
      // Remove todos os registros antigos relacionados ao mesmo negócio
      listaAtual = listaAtual.filter(
        (registro) => {
          const chaveNegocioRegistro = String(
            registro?.numeroProposta || registro?.numeroSolicitacao || registro?.code || registro?.codigo || ""
          ).trim();
          return chaveNegocioRegistro !== chaveNegocio;
        }
      );
      // Adiciona o novo registro
      listaAtual.unshift(normalizado);

      this.orcamentos = this.ordenarOrcamentosLista(listaAtual);
    },

    async carregarPorIds(service, ids = []) {
      const idsValidos = Array.isArray(ids) ? ids.filter(Boolean) : [];
      if (!idsValidos.length) return [];

      let listaInicial = [];
      try {
        const response = await service.getAll(1, Math.max(idsValidos.length, 50), "", "", idsValidos, null, null, null);
        const lista = this.extrairListaResponse(response);
        listaInicial = Array.isArray(lista) ? lista : [];
      } catch (_) {
        listaInicial = [];
      }

      const mapa = new Map();
      listaInicial.forEach((item) => {
        const id = this.obterIdRegistro(item);
        if (id) mapa.set(id, item);
      });

      const idsFaltantes = idsValidos.filter((id) => !mapa.has(id));
      for (const id of idsFaltantes) {
        try {
          const response = await service.getById(id);
          const item = this.obterRegistroResponse(response);
          const itemId = this.obterIdRegistro(item);
          if (itemId) mapa.set(itemId, item);
        } catch (_) {
          // ignora id inexistente e continua
        }
      }

      return Array.from(mapa.values());
    },

    async buscarRelacionadosPorCampos(service, registroId, campos = []) {
      const acumulado = [];
      for (const campo of campos) {
        try {
          const response = await service.search(campo, registroId, 1, 500, null, "Equals");
          const lista = this.extrairListaResponse(response);
          if (Array.isArray(lista) && lista.length > 0) {
            acumulado.push(...lista);
          }
        } catch (error) {
          // tenta próximo campo
        }
      }

      const mapa = new Map();
      acumulado.forEach((item) => {
        const id = this.obterIdRegistro(item) || item?.code || item?.codigo || JSON.stringify(item);
        if (!mapa.has(id)) mapa.set(id, item);
      });

      return Array.from(mapa.values());
    },

    async buscarRevisoesPorNumeroBase(service, numeroBase = "") {
      const base = String(numeroBase || "").trim().toUpperCase();
      if (!base) return [];

      const campos = ["numeroProposta", "numeroSolicitacao", "codigo", "code"];
      const acumulado = [];

      for (const campo of campos) {
        try {
          const response = await service.search(campo, base, 1, 500, null, "Contains");
          const lista = this.extrairListaResponse(response);
          if (Array.isArray(lista) && lista.length > 0) {
            acumulado.push(...lista);
          }
        } catch (_) {
          // ignora campo sem suporte e continua
        }
      }

      const mapa = new Map();
      acumulado.forEach((item) => {
        const id = this.obterIdRegistro(item) || item?.code || item?.codigo || JSON.stringify(item);
        if (!mapa.has(id)) mapa.set(id, item);
      });

      return Array.from(mapa.values());
    },

    async buscarRevisoesFallbackGlobal(service, numeroBase = "") {
      const base = String(numeroBase || "").trim().toUpperCase();
      if (!base) return [];

      try {
        const response = await service.getAll(1, 2000, "", "", null, null, null, null);
        const lista = this.extrairListaResponse(response);
        const listaValida = Array.isArray(lista) ? lista : [];

        const filtrada = listaValida.filter((item) => {
          const snapshot = this.parseSnapshotRevisao(item);
          const referencia =
            item?.numeroProposta ||
            item?.numeroSolicitacao ||
            item?.codigo ||
            item?.code ||
            snapshot?.numeroProposta ||
            snapshot?.numeroSolicitacao ||
            snapshot?.codigo ||
            snapshot?.code ||
            "";

          const baseItem = this.extrairNumeroPropostaBase(referencia);
          return Boolean(baseItem) && baseItem === base;
        });

        const mapa = new Map();
        filtrada.forEach((item) => {
          const id = this.obterIdRegistro(item) || item?.code || item?.codigo || JSON.stringify(item);
          if (!mapa.has(id)) mapa.set(id, item);
        });

        return Array.from(mapa.values());
      } catch (_) {
        return [];
      }
    },

    mapearFollowUp(item = {}) {
      return {
        ...item,
        id: item.id || item._id || null,
        code: item.code || item.codigo || "",
        description: item.description || item.descricao || "",
        data: this.normalizarDataParaInput(item.data || item.dataCriacao || ""),
        contato_comercial:
          item.contato_comercial ||
          item.contatoComercialNome ||
          item.contatoComercial ||
          "",
        statusDescription:
          item.statusDescription ||
          item.status?.description ||
          this.statusDescricaoPorId[item.status] ||
          ""
      };
    },

    mapearRevisao(item = {}) {
      const snapshot = this.parseSnapshotRevisao(item);
      const itemComFallback = {
        ...item
      };

      const tipoDados = this.resolverDadosTipoEquipamento(itemComFallback);
      const tipoEquipamento =
        tipoDados.tipoDescricao ||
        this.obterDescricaoTipoEquipamento(
          itemComFallback._mirror_tipoDeEquipamento || itemComFallback.tipoDeEquipamento
        );

      const revisaoFonte =
        itemComFallback.revisao ||
        itemComFallback.version ||
        itemComFallback.ultimaRevisao ||
        snapshot?.revisao ||
        snapshot?.version ||
        snapshot?.ultimaRevisao ||
        this.extrairRevisaoDeCodigoHistorico(itemComFallback.code || itemComFallback.codigo || snapshot?.code || snapshot?.codigo || "") ||
        "ORIGINAL";

      const numeroProposta =
        itemComFallback.numeroProposta ||
        itemComFallback.numeroSolicitacao ||
        snapshot?.numeroProposta ||
        snapshot?.numeroSolicitacao ||
        itemComFallback.codigoOriginal ||
        itemComFallback.codeAnterior ||
        snapshot?.codigoOriginal ||
        snapshot?.codeAnterior ||
        itemComFallback.codigo ||
        itemComFallback.code ||
        snapshot?.codigo ||
        snapshot?.code ||
        "";

      return {
        ...itemComFallback,
        numeroProposta,
        revisao: this.normalizarCodigoRevisao(revisaoFonte),
        dateGenerate:
          itemComFallback.dateGenerate ||
          itemComFallback.dataGeracao ||
          itemComFallback.data ||
          snapshot?.dateGenerate ||
          snapshot?.dataGeracao ||
          snapshot?.data ||
          "",
        statusDescription:
          itemComFallback.statusDescription ||
          snapshot?.statusDescription ||
          itemComFallback.status?.description ||
          snapshot?.status?.description ||
          this.statusDescricaoPorId[itemComFallback.status] ||
          this.statusDescricaoPorId[snapshot?.status] ||
          "",
        _mirror_tipoDeEquipamento: tipoEquipamento,
        _revisaoAtual: Boolean(item._revisaoAtual)
      };
    },

    async atualizarVinculoFollowUpsNoSalesOrder(ids = []) {
      const idsRecebidos = Array.isArray(ids) ? ids : [];
      const idsUnicosRecebidos = [...new Set(idsRecebidos.filter(Boolean))];

      const origemSchema = "SalesOrder";
      const servicePersistencia = this.salesOrderLegadoService;

      let registroAtual = {};
      try {
        const responseAtual = await servicePersistencia.getById(this.formulario.id);
        const candidato = responseAtual?.data?.data || responseAtual?.data || {};
        registroAtual = (candidato && typeof candidato === "object" && !Array.isArray(candidato))
          ? candidato
          : {};
      } catch (_) {
        registroAtual = {};
      }

      const idsExistentes = [
        ...(Array.isArray(registroAtual?.followUp) ? registroAtual.followUp : []),
        ...(Array.isArray(registroAtual?.followUps) ? registroAtual.followUps : []),
        ...(Array.isArray(registroAtual?.salesOrderFollowUps) ? registroAtual.salesOrderFollowUps : []),
        ...(Array.isArray(registroAtual?.followup) ? registroAtual.followup : []),
        ...(Array.isArray(this.formulario?.followUps) ? this.formulario.followUps : []),
        ...(Array.isArray(this.formulario?.salesOrderFollowUps) ? this.formulario.salesOrderFollowUps : [])
      ].filter(Boolean);

      const idsFinais = [...new Set([...idsExistentes, ...idsUnicosRecebidos])];

      const camposPersistencia = ["followUp", "followup"];

      let ultimoErro = null;

      for (const campo of camposPersistencia) {
        try {
          await servicePersistencia.insertOrUpdate({
            id: this.formulario.id,
            [campo]: idsFinais
          });

          this.formulario.followUp = idsFinais;
          this.formulario.followUps = idsFinais;
          this.formulario.followup = idsFinais;
          this.formulario.salesOrderFollowUps = idsFinais;

          this.atualizarOrcamentoNaLista({
            ...this.formulario,
            followUp: idsFinais,
            followUps: idsFinais,
            followup: idsFinais,
            salesOrderFollowUps: idsFinais,
            [campo]: idsFinais
          }, origemSchema);
          return;
        } catch (error) {
          ultimoErro = error;
        }
      }

      if (ultimoErro) throw ultimoErro;
    },

    async atualizarVinculoRevisoesNoSalesOrder(ids = []) {
      const idsRecebidos = Array.isArray(ids) ? ids : [];
      const idsUnicosRecebidos = [...new Set(idsRecebidos.filter(Boolean))];

      let salesOrderAtual = { id: this.formulario.id };
      try {
        const salesOrderResponse = await this.salesOrderLegadoService.getById(this.formulario.id);
        const candidato = salesOrderResponse?.data?.data || salesOrderResponse?.data || {};
        salesOrderAtual = (candidato && typeof candidato === "object" && !Array.isArray(candidato))
          ? candidato
          : { id: this.formulario.id };
      } catch (_) {
        salesOrderAtual = { id: this.formulario.id };
      }

      const idsExistentes = [
        ...(Array.isArray(salesOrderAtual?.revisoes) ? salesOrderAtual.revisoes : []),
        ...(Array.isArray(salesOrderAtual?.revisoesComerciais) ? salesOrderAtual.revisoesComerciais : []),
        ...(Array.isArray(this.formulario?.revisoes) ? this.formulario.revisoes : []),
        ...(Array.isArray(this.formulario?.revisoesComerciais) ? this.formulario.revisoesComerciais : [])
      ].filter(Boolean);

      const idsFinais = [...new Set([...idsExistentes, ...idsUnicosRecebidos])];

      const camposPossiveis = ["revisoes", "revisoesComerciais"];
      let ultimoErro = null;

      for (const campo of camposPossiveis) {
        try {
          await this.salesOrderLegadoService.insertOrUpdate({
            id: this.formulario.id,
            [campo]: idsFinais
          });

          this.formulario.revisoes = idsFinais;
          this.formulario.revisoesComerciais = idsFinais;
          return;
        } catch (error) {
          ultimoErro = error;
        }
      }

      if (ultimoErro) throw ultimoErro;
    },

    async carregarContatosDoCliente(clienteId) {
      if (!clienteId) {
        this.contatosCliente = [];
        this.contatosComerciaisCliente = [];
        this.contatosTecnicosCliente = [];
        return;
      }

      try {
        let contatosPorIds = [];
        try {
          const clienteResponse = await this.clienteService.getById(clienteId);
          const cliente = clienteResponse?.data?.data || clienteResponse?.data || {};
          const idsContatos = Array.isArray(cliente?.contatos) ? cliente.contatos.filter(Boolean) : [];
          if (idsContatos.length) {
            contatosPorIds = await this.carregarPorIds(this.contatoService, idsContatos);
          }
        } catch (_) {
          // fallback abaixo
        }

        if (!contatosPorIds.length) {
          const response = await this.contatoService.search("cliente", clienteId, 1, 1000, null, "Equals");
          const lista = response?.data?.data?.data || response?.data?.data || response?.data || [];
          contatosPorIds = Array.isArray(lista) ? lista : [];
        }

        this.contatosCliente = Array.isArray(contatosPorIds) ? contatosPorIds : [];

        const comerciais = this.contatosCliente.filter((item) => this.contatoEhComercial(item));
        const tecnicos = this.contatosCliente.filter((item) => this.contatoEhTecnico(item));

        this.contatosComerciaisCliente = comerciais.length ? comerciais : [...this.contatosCliente];
        this.contatosTecnicosCliente = tecnicos.length
          ? tecnicos
          : (comerciais.length ? comerciais : [...this.contatosCliente]);
        this.sincronizarContatosDoFormulario();
      } catch (error) {
        this.contatosCliente = [];
        this.contatosComerciaisCliente = [];
        this.contatosTecnicosCliente = [];
      }
    },

    async selecionarCliente(clienteId) {
      if (!clienteId) {
        this.formulario.cliente = null;
        this.formulario.clienteNome = "";
        this.formulario.clienteCnpj = "";
        this.preencherContatoNoFormulario(null);
        this.preencherContatoTecnicoNoFormulario(null);
        this.contatosCliente = [];
        this.contatosComerciaisCliente = [];
        this.contatosTecnicosCliente = [];
        return;
      }

      this.formulario.cliente = clienteId || null;
      this.formulario.clienteNome = this.getClienteNomePorId(clienteId);
      this.formulario.clienteCnpj = this.getClienteCnpjPorId(clienteId);
      this.preencherContatoNoFormulario(null);
      this.preencherContatoTecnicoNoFormulario(null);
      await this.carregarContatosDoCliente(clienteId);
    },

    selecionarContato(contatoId) {
      const contato = this.getContatoPorId(contatoId);
      this.preencherContatoNoFormulario(contato);
    },

    selecionarContatoTecnico(contatoId) {
      const contato = this.getContatoPorId(contatoId);
      this.preencherContatoTecnicoNoFormulario(contato);
    },

    async criarContato() {
      this.$notfy?.warning("Nesta tela, os contatos devem ser apenas selecionados do cadastro existente");
    },

    validarCamposParaGerarJob(validarStatusConcluido = true) {
      const f = this.formulario;
      const faltantes = [];

      if (validarStatusConcluido && !this.statusOrcamentoConcluido(f)) {
        faltantes.push({ secao: "Dados Gerais", campo: "status", label: "Status da Solicitação (Concluído)" });
      }

      // Dados Gerais
      if (!f.cliente) {
        faltantes.push({ secao: "Dados Gerais", campo: "cliente", label: "Cliente" });
      }
      if (!f.tipoDeEquipamento) {
        faltantes.push({ secao: "Dados Gerais", campo: "tipoDeEquipamento", label: "Tipo de Equipamento" });
      }

      // Parte Técnica
      if (!f.projetoDescricao && !f.descricao) {
        faltantes.push({ secao: "Proposta Técnica", campo: "projetoDescricao", label: "Descrição do Projeto" });
      }
      if (!f.dataDesejada) {
        faltantes.push({ secao: "Proposta Técnica", campo: "dataDesejada", label: "Data Desejada" });
      }

      // Parte Comercial
      if (!f.vendedor) {
        faltantes.push({ secao: "Proposta Comercial", campo: "vendedor", label: "Vendedor" });
      }
      if (!f.orcamentista) {
        faltantes.push({ secao: "Proposta Comercial", campo: "orcamentista", label: "Orçamentista" });
      }
      if (!(f.contatoComercial || f.contato || f.contatoNome || f.contatoComercialNome)) {
        faltantes.push({ secao: "Proposta Comercial", campo: "contato", label: "Contato Comercial" });
      }
      if (parseNumero(f.precoVenda_sIPI_cICMS) <= 0) {
        faltantes.push({ secao: "Proposta Comercial", campo: "precoVenda_sIPI_cICMS", label: "Preço de Venda c/ICMS s/IPI" });
      }
      if (parseNumero(f.valorDisponivel) <= 0) {
        faltantes.push({ secao: "Proposta Comercial", campo: "valorDisponivel", label: "Custo Disponível s/ICMS" });
      }

      return faltantes;
    },

    async gerarJob() {
      if (!this.formulario?.id) {
        this.$notfy?.warning("Salve a Solicitação de Orçamento antes de gerar o Job");
        return;
      }

      if (this.registroPossuiJobAssociado(this.formulario)) {
        this.$notfy?.warning("Já existe um Job vinculado. Abrindo em nova aba...");
        window.open("/#/tela/job", "_blank");
        return;
      }

      if (!this.statusOrcamentoConcluido(this.formulario)) {
        this.$notfy?.warning("Apenas Solicitações com status CONCLUÍDO podem gerar Job");
        return;
      }

      // Validar campos obrigatórios
      const faltantes = this.validarCamposParaGerarJob();
      if (faltantes.length > 0) {
        this.contextoCamposFaltantes = "job";
        this.camposFaltantes = faltantes;
        this.dialogCamposFaltantes = true;
        return;
      }

      try {
        this.carregando = true;
        const usuarioLogadoId = await this.obterUsuarioLogadoId();
        const colaboradorLogado = await this.obterColaboradorLogado();
        const colaboradorLogadoId = colaboradorLogado?.id || null;
        const colaboradorLogadoNome = colaboradorLogado?.nome || this.usuarioNome || "";
        // Comercial deve sempre receber o id do schema Collaborator (nunca userId)
        const comercialCriadorId = colaboradorLogadoId || null;

        const vendedorNome =
          this.formulario.vendedorNome ||
          this.getColaboradorNomePorId(this.formulario.vendedor);
        const orcamentistaNome =
          this.formulario.orcamentistaNome ||
          this.getColaboradorNomePorId(this.formulario.orcamentista);
        const valorJob = parseNumero(
          this.formulario.precoVenda_sIPI_cICMS ||
          this.formulario.valorEstimado ||
          this.formulario.valorDisponivel
        );
        const valorIpiInformado = parseNumero(
          this.formulario.valorIPI ||
          this.formulario.valorIpi ||
          this.formulario.valor_ipi ||
          0
        );
        const porcentagemIpi = parseNumero(
          this.formulario.pocentagemIPIVenda ||
          this.formulario.porcentagemIPI ||
          0
        );
        const valorIpiCalculado = valorJob * (porcentagemIpi / 100);
        const valorIpi = valorIpiInformado > 0 ? valorIpiInformado : valorIpiCalculado;
        const valorComIPIComICMS = valorJob + valorIpi;

        // Obter nomes dos contatos
        const contatoComercialObj = this.getContatoPorId(this.formulario.contatoComercial || this.formulario.contato);
        const contatoTecnicoObj = this.getContatoPorId(this.formulario.contatoTecnico);
        const contatoComercialNome = contatoComercialObj?.nome || this.formulario.contatoNome || this.formulario.contatoComercialNome || "";
        const contatoTecnicoNome = contatoTecnicoObj?.nome || this.formulario.contatoTecnicoNome || "";
        const codigoSolicitacao = this.formulario.numeroProposta || this.formulario.numeroSolicitacao || this.formulario.code || this.formulario.codigo || "";
        const codigoJob = await this.gerarCodigoJobPorSequenciaSchema();
        const dataAbertura = UtilDateTime.todayUTC();

        const isSalesOrderLegado = true;

        // Determina o tipo do Job com base na sigla do tipo de equipamento do orçamento
        const siglaTipoEquipamento = String(this.formulario.tipoDeEquipamentoSigla || "").trim().toUpperCase().slice(0, 3);
        const jobTipo = (siglaTipoEquipamento === "DPS" || siglaTipoEquipamento === "PPS") ? "Sobressalente" : "Padrão";

        const payloadJob = {
          status: "Iniciado",
          jobTipo,
          code: codigoJob,
          dataAbertura,
          dataEntregaContratual: null,
          dateFinalContratual: null,
          dateFinalEfetiva: null,
          valorAtual: valorJob,
          valorJob,
          valorInicialJob: valorJob,
          valorComIPIComICMS,
          description: `Gerado pela solicitação de orçamento ${codigoSolicitacao}`,
          condicaoDePagamento: "",
          observacao: "",
          solicitacaoDeOrcamento: this.formulario.id || undefined,
          solicitacaoDeOrcamentoId: this.formulario.id || undefined,
          salesOrder: isSalesOrderLegado ? this.formulario.id : undefined,
          salesOrderId: isSalesOrderLegado ? this.formulario.id : undefined,
          salesOrderCode: isSalesOrderLegado
            ? codigoSolicitacao
            : undefined,
          solicitacaoDeOrcamentoCodigo: codigoSolicitacao,
          numeroProposta: codigoSolicitacao,
          cliente: this.formulario.cliente || null,
          clienteNome: this.formulario.clienteNome || this.getClienteNomePorId(this.formulario.cliente),
          vendedorNome,
          orcamentistaNome,
          // tipo deve ser apenas o ID (não o objeto completo)
          tipo: this.formulario.tipoDeEquipamento || undefined,
          tipoDescription: this.formulario.tipoDeEquipamentoDescricao || undefined,
          contatoComercial: this.formulario.contatoComercial || this.formulario.contato || null,
          contatoComercialNome,
          contatoTecnico: this.formulario.contatoTecnico || null,
          contatoTecnicoNome,
          revisaoSolicitacaoOrcamento: this.formulario.version || this.formulario.codigo || "",
          pedidoCompra: "",
          email: "",
          emailXML: "",
          comercial: comercialCriadorId || undefined,
          comercialId: comercialCriadorId || undefined,
          comercialID: comercialCriadorId || undefined,
          comercialNome: colaboradorLogadoNome || undefined,
          owner: usuarioLogadoId || undefined,
          ownerId: usuarioLogadoId || undefined,
          owners: usuarioLogadoId ? [usuarioLogadoId] : undefined
        };

        if (!payloadJob.comercial) delete payloadJob.comercial;
        if (!payloadJob.comercialId) delete payloadJob.comercialId;
        if (!payloadJob.comercialID) delete payloadJob.comercialID;
        if (!payloadJob.comercialNome) delete payloadJob.comercialNome;
        if (!payloadJob.owner) delete payloadJob.owner;
        if (!payloadJob.ownerId) delete payloadJob.ownerId;
        if (!payloadJob.owners) delete payloadJob.owners;
        if (!payloadJob.code) delete payloadJob.code;
        if (!payloadJob.solicitacaoDeOrcamento) delete payloadJob.solicitacaoDeOrcamento;
        if (!payloadJob.solicitacaoDeOrcamentoId) delete payloadJob.solicitacaoDeOrcamentoId;
        if (!payloadJob.salesOrder) delete payloadJob.salesOrder;
        if (!payloadJob.salesOrderId) delete payloadJob.salesOrderId;
        if (!payloadJob.salesOrderCode) delete payloadJob.salesOrderCode;
        if (!payloadJob.solicitacaoDeOrcamentoCodigo) delete payloadJob.solicitacaoDeOrcamentoCodigo;
        if (!payloadJob.tipo) delete payloadJob.tipo;
        if (!payloadJob.contatoComercial) delete payloadJob.contatoComercial;
        if (!payloadJob.contatoTecnico) delete payloadJob.contatoTecnico;

        const responseJob = await this.jobService.insertOrUpdate(payloadJob);

        // O apiClient não rejeita em 4xx — verifica manualmente o sucesso
        if (responseJob?.success === false) {
          const erros = Array.isArray(responseJob?.data)
            ? responseJob.data.map((e) => e.value).join("\n")
            : "Não foi possível criar o Job. Verifique os dados e tente novamente.";
          throw new Error(erros);
        }

        let jobCriado = this.obterRegistroResponse(responseJob) || responseJob;
        const jobIdGerado = this.obterIdJob(jobCriado);
        const jobNomeGerado = this.obterCodigoJob(jobCriado) || codigoJob;

        if (!jobIdGerado) {
          throw new Error("Job criado sem ID de retorno. Não foi possível vincular ao orçamento.");
        }

        const extrairComercialId = (job = {}) => {
          const comercial = job?.comercial;
          if (typeof comercial === "object") {
            return comercial?.id || comercial?._id || null;
          }
          return comercial || job?.comercialId || job?.comercialID || null;
        };

        let comercialNoRetorno = extrairComercialId(jobCriado);
        if (!comercialNoRetorno && comercialCriadorId) {
          try {
            const responseAjusteComercial = await this.jobService.insertOrUpdate({
              id: jobIdGerado,
              comercial: comercialCriadorId,
              comercialId: comercialCriadorId,
              comercialID: comercialCriadorId,
              comercialNome: colaboradorLogadoNome || undefined
            });

            if (responseAjusteComercial?.success === false) {
              throw new Error("Não foi possível confirmar o comercial no Job gerado");
            }

            const responseJobDetalhe = await this.jobService.getById(jobIdGerado);
            jobCriado = this.obterRegistroResponse(responseJobDetalhe) || jobCriado;
            comercialNoRetorno = extrairComercialId(jobCriado);
          } catch (erroComercial) {
            this.debugSolicitacao("gerarJob:falha-ajuste-comercial", {
              jobIdGerado,
              comercialEsperado: comercialCriadorId,
              message: erroComercial?.message
            });
          }
        }

        if (!comercialNoRetorno && comercialCriadorId) {
          this.$notfy?.warning("Job gerado, mas não foi possível confirmar o Comercial automaticamente");
        }

        this.formulario.vendedorNome = vendedorNome;
        this.formulario.orcamentistaNome = orcamentistaNome;

        const servicePersistencia = this.salesOrderLegadoService;

        let payloadOrcamento = {
          ...gerarPayloadPersistencia(this.formulario),
          id: this.formulario.id,
          job: jobIdGerado,
          jobNome: jobNomeGerado,
          status: STATUS_PEDIDO_COLOCADO_ID,
          statusDescription: STATUS_PEDIDO_COLOCADO_DESC,
          dateGenerate: new Date().toISOString().split("T")[0],
          tipoDeEquipamento: this.formulario.tipoDeEquipamento || null,
          tipoDeEquipamentoSigla: this.formulario.tipoDeEquipamentoSigla || "",
          tipoDeEquipamentoDescricao: this.formulario.tipoDeEquipamentoDescricao || "",
          contatoComercialNome: this.formulario.contatoNome || this.formulario.contatoComercialNome || "",
          contatoTecnicoNome: this.formulario.contatoTecnicoNome || ""
        };

        if (isSalesOrderLegado) {
          // Para SalesOrder: _mirror_tipoDeEquipamento deve ser o ID, não o objeto
          payloadOrcamento._mirror_tipoDeEquipamento = this.formulario.tipoDeEquipamento || "";
          payloadOrcamento = this.sanitizarPayloadSalesOrder(payloadOrcamento);
        }

        const responseOrcamento = await servicePersistencia.insertOrUpdate(payloadOrcamento);

        if (responseOrcamento?.success === false) {
          const erros = Array.isArray(responseOrcamento?.data)
            ? responseOrcamento.data.map((e) => e.value).join("\n")
            : "Job criado, mas não foi possível atualizar o status da Solicitação.";
          throw new Error(erros);
        }

        this.aplicarJobNoFormulario({ ...jobCriado, id: jobIdGerado, code: jobNomeGerado });
        this.formulario.status = STATUS_PEDIDO_COLOCADO_ID;
        this.formulario.statusDescription = STATUS_PEDIDO_COLOCADO_DESC;
        this.atualizarOrcamentoNaLista(payloadOrcamento, "SalesOrder");

        this.$notfy?.success("Job gerado com sucesso");
        window.open("/#/tela/job", "_blank");
      } catch (error) {
        const mensagem =
          error?.message ||
          error?.response?.data?.message ||
          "Não foi possível gerar o Job desta Solicitação de Orçamento";
        this.$notfy?.error(mensagem);
        console.error(error);
      } finally {
        this.carregando = false;
      }
    },

    async gerarCapaProposta() {
      try {
        this.carregando = true;
        await UtilCapaPropostaPDF.gerarCapaProposta(this.formulario);
        this.$notfy?.success("Capa da proposta gerada com sucesso");
      } catch (error) {
        const mensagem =
          error?.message ||
          error?.response?.data?.message ||
          "Não foi possível gerar a capa da proposta";
        this.$notfy?.error(mensagem);
        console.error(error);
      } finally {
        this.carregando = false;
      }
    },

    novaPropostaTecnica() {
      this.$notfy?.warning("Abertura de Proposta Técnica em desenvolvimento");
    },

    novaPropostaComercial() {
      this.$notfy?.warning("Abertura de Proposta Comercial em desenvolvimento");
    },

    async novoFollowUp(formData = {}) {
      if (!this.formulario?.id) {
        this.$notfy?.warning("Salve a Solicitação de Orçamento antes de criar Follow-Up");
        return;
      }

      try {
        this.carregando = true;

        const descricaoFollowUp = String(formData.description || "").trim();
        const statusSelecionado = formData.status;
        if (!descricaoFollowUp) {
          this.$notfy?.warning("Descrição do Follow-Up é obrigatória");
          return;
        }
        if (!statusSelecionado) {
          this.$notfy?.warning("Status do Follow-Up é obrigatório");
          return;
        }

        const statusDescricaoSelecionado =
          (this.statusOpcoes || []).find((item) => item?.id === statusSelecionado)?.description || "";
        const exigeContatoComercial =
          this.normalizarTextoComparacao(statusDescricaoSelecionado) === "concluido";

        const contatoComercialFollowUp = String(formData.contato_comercial || "").trim();

        if (exigeContatoComercial && !contatoComercialFollowUp) {
          this.$notfy?.warning("Para status CONCLUÍDO, o contato comercial é obrigatório no Follow-Up");
          return;
        }

        const dataFollowUp = this.normalizarDataParaInput(formData.data || UtilDateTime.todayISO());
        const payloadBase = {
          description: descricaoFollowUp,
          data: UtilDateTime.toFormatUTC({ dateTime: dataFollowUp }) || UtilDateTime.todayUTC(),
          contato_comercial: contatoComercialFollowUp,
          salesOrder: this.formulario.id,
          solicitacaoOrcamento: this.formulario.id,
          solicitacaoOrcamentoId: this.formulario.id
        };
        payloadBase.status = statusSelecionado;

        const response = await this.followUpService.insertOrUpdate(payloadBase);
        const followUpCriadoId = response?.data?.data?.id || response?.data?.id || null;

        if (followUpCriadoId) {
          const followUpsAtuaisFormulario = Array.isArray(this.formulario.followUps)
            ? this.formulario.followUps
            : [];
          const followUpsAtuaisSalesOrder = Array.isArray(this.formulario.salesOrderFollowUps)
            ? this.formulario.salesOrderFollowUps
            : [];
          const followUpsAtuaisLista = Array.isArray(this.followUps)
            ? this.followUps.map((item) => item?.id || item?._id).filter(Boolean)
            : [];

          const followUpsAtuais = [
            ...followUpsAtuaisFormulario,
            ...followUpsAtuaisSalesOrder,
            ...followUpsAtuaisLista
          ];
          const followUpsAtualizados = [...new Set([...followUpsAtuais, followUpCriadoId])];
          try { await this.atualizarVinculoFollowUpsNoSalesOrder(followUpsAtualizados); } catch (_) { /* vínculo via campo salesOrder no FU */ }
        }

        if (statusSelecionado) {
          const statusDescricao =
            this.statusDescricaoPorId[statusSelecionado] ||
            (this.statusOpcoes || []).find((item) => item?.id === statusSelecionado)?.description ||
            "";
          this.formulario.status = statusSelecionado;
          if (statusDescricao) {
            this.formulario.statusDescription = statusDescricao;
          }

          this.atualizarOrcamentoNaLista(
            {
              ...this.formulario,
              status: this.formulario.status,
              statusDescription: this.formulario.statusDescription
            },
            "SalesOrder"
          );

          this.debugSolicitacao("novoFollowUp:statusAplicado", {
            formularioId: this.formulario?.id,
            statusSelecionado,
            statusDescricao,
            origemSchema: this.formulario?.origemSchema
          });

          const servicePersistencia = this.salesOrderLegadoService;

          try {
            let registroAtual = { ...this.formulario };
            try {
              const responseAtual = await servicePersistencia.getById(this.formulario.id);
              registroAtual = {
                ...registroAtual,
                ...(this.obterRegistroResponse(responseAtual) || {})
              };
            } catch (_) {
              // fallback para dados já carregados em memória
            }

            const numeroPropostaAtual =
              registroAtual?.numeroProposta ||
              registroAtual?.numeroSolicitacao ||
              registroAtual?.code ||
              registroAtual?.codigo ||
              "";

            const tipoDados = this.resolverDadosTipoEquipamento(registroAtual);
            const statusDescriptionPersistir =
              statusDescricao ||
              registroAtual?.statusDescription ||
              this.statusDescricaoPorId[statusSelecionado] ||
              "";

            let payloadStatus = {
              ...gerarPayloadPersistencia({
                ...criarFormularioPadrao(),
                ...registroAtual,
                numeroProposta: numeroPropostaAtual
              }),
              id: this.formulario.id,
              numeroProposta: numeroPropostaAtual,
              codigo:
                registroAtual?.codigo ||
                registroAtual?.code ||
                numeroPropostaAtual,
              code:
                registroAtual?.code ||
                registroAtual?.codigo ||
                numeroPropostaAtual,
              numeroSolicitacao:
                registroAtual?.numeroSolicitacao ||
                registroAtual?.code ||
                registroAtual?.codigo ||
                numeroPropostaAtual,
              status: statusSelecionado,
              statusDescription: statusDescriptionPersistir,
              tipoDeEquipamento: tipoDados?.tipoId || registroAtual?.tipoDeEquipamento || null,
              tipoDeEquipamentoSigla: tipoDados?.tipoSigla || registroAtual?.tipoDeEquipamentoSigla || "",
              tipoDeEquipamentoDescricao: tipoDados?.tipoDescricao || registroAtual?.tipoDeEquipamentoDescricao || "",
              _mirror_tipoDeEquipamento: registroAtual?._mirror_tipoDeEquipamento || ""
            };

            payloadStatus._mirror_tipo =
              tipoDados?.tipoSigla ||
              registroAtual?._mirror_tipo ||
              "";
            payloadStatus._mirror_tipoDeEquipamento =
              tipoDados?.tipoId ||
              payloadStatus._mirror_tipoDeEquipamento ||
              "";
            payloadStatus = this.sanitizarPayloadSalesOrder(payloadStatus);

            await servicePersistencia.insertOrUpdate(payloadStatus);
          } catch (erroStatus) {
            console.error("Falha ao atualizar status após criar Follow-Up", erroStatus);
          }
        }

        this.$notfy?.success("Follow-Up incluído com sucesso");
        try {
          // Recarrega sub-entidades (follow-ups)
          await this.carregarSubEntidades(this.formulario.id);
          // Atualiza lista local apenas, sem reload completo
          this.atualizarOrcamentoNaLista(this.formulario, "SalesOrder");
        } catch (erroSubEntidades) {
          console.error("Falha ao recarregar Follow-Ups após criação", erroSubEntidades);
        }
      } catch (error) {
        const mensagem = error?.response?.data?.message || "Não foi possível incluir o Follow-Up";
        this.$notfy?.error(mensagem);
        console.error(error);
      } finally {
        this.carregando = false;
      }
    },

    async editarFollowUp(item = {}) {
      const id = item?.id || item?._id;
      if (!id) return;

      try {
        this.carregando = true;
        const payload = {
          ...item,
          id,
          data: item?.data
            ? UtilDateTime.toFormatUTC({ dateTime: this.normalizarDataParaInput(item.data) })
            : UtilDateTime.todayUTC(),
          salesOrder: item.salesOrder || this.formulario.id,
          solicitacaoOrcamento: item.solicitacaoOrcamento || this.formulario.id,
          solicitacaoOrcamentoId: item.solicitacaoOrcamentoId || this.formulario.id
        };
        if (!payload.status) delete payload.status;
        await this.followUpService.insertOrUpdate(payload);
        this.$notfy?.success("Follow-Up atualizado com sucesso");
        await this.carregarSubEntidades(this.formulario.id);
      } catch (error) {
        const mensagem = error?.response?.data?.message || "Erro ao atualizar Follow-Up";
        this.$notfy?.error(mensagem);
      } finally {
        this.carregando = false;
      }
    },

    async deletarFollowUp(item = {}) {
      const id = item?.id || item?._id;
      if (!id) return;

      const confirmar = window.confirm("Tem certeza que deseja excluir este Follow-Up?");
      if (!confirmar) return;

      try {
        this.carregando = true;
        await this.followUpService.delete(id);

        const followUpsAtuais = Array.isArray(this.formulario.followUps)
          ? this.formulario.followUps
          : (Array.isArray(this.formulario.salesOrderFollowUps) ? this.formulario.salesOrderFollowUps : []);

        const followUpsAtualizados = followUpsAtuais.filter((followUpId) => followUpId !== id);
        await this.atualizarVinculoFollowUpsNoSalesOrder(followUpsAtualizados);

        this.$notfy?.success("Follow-Up removido com sucesso");
        await this.carregarSubEntidades(this.formulario.id);
      } catch (error) {
        const mensagem = error?.response?.data?.message || "Erro ao excluir Follow-Up";
        this.$notfy?.error(mensagem);
      } finally {
        this.carregando = false;
      }
    },

    async carregarSubEntidades(salesOrderId) {
      this.propostasTecnicas = [];
      this.propostasComerciais = [];
      this.followUps = [];
      this.revisoes = [];

      if (!salesOrderId) return;

      try {
        const idsItens = [
          ...(Array.isArray(this.formulario?.Itens) ? this.formulario.Itens : []),
          ...(Array.isArray(this.formulario?.itens) ? this.formulario.itens : [])
        ]
          .map((item) => (typeof item === "string" ? item : this.obterIdRegistro(item)))
          .filter(Boolean);

        if (idsItens.length) {
          const itensLista = await this.carregarPorIds(this.salesOrderItemService, idsItens);
          if (Array.isArray(itensLista) && itensLista.length) {
            this.formulario.itens = itensLista.map((item) => normalizarItem(item));
            this.formulario.Itens = [...new Set(itensLista.map((item) => this.obterIdRegistro(item)).filter(Boolean))];
            this.aplicarCamposDeItens();
          }
        }
      } catch (_) {
        // mantém itens atuais em memória
      }

      try {
        const idsFollowUps =
          this.formulario?.followUps ||
          this.formulario?.salesOrderFollowUps ||
          this.formulario?.followUp ||
          this.formulario?.followup ||
          [];

        let followUpsLista = await this.carregarPorIds(this.followUpService, idsFollowUps);
        if (!followUpsLista.length) {
          followUpsLista = await this.buscarRelacionadosPorCampos(this.followUpService, salesOrderId, [
            "salesOrder",
            "salesOrderId",
            "solicitacaoOrcamento",
            "solicitacaoOrcamentoId"
          ]);
        }
        this.followUps = (Array.isArray(followUpsLista) ? followUpsLista : []).map((item) => this.mapearFollowUp(item));
        const followUpsIds = this.followUps
          .map((item) => item?.id || item?._id)
          .filter(Boolean);
        if (followUpsIds.length) {
          this.formulario.followUps = [...new Set(followUpsIds)];
          this.formulario.salesOrderFollowUps = [...new Set(followUpsIds)];
        }
      } catch (error) {
        this.followUps = [];
      }

      try {
        const idsRevisoes = [
          ...(Array.isArray(this.formulario?.revisoesComerciais) ? this.formulario.revisoesComerciais : []),
          ...(Array.isArray(this.formulario?.revisoes) ? this.formulario.revisoes : [])
        ].filter(Boolean);
        const numeroBaseAtual = this.extrairNumeroPropostaBase(
          this.formulario?.numeroProposta ||
          this.formulario?.numeroSolicitacao ||
          this.formulario?.codigo ||
          this.formulario?.code ||
          ""
        );

        const revisoesPorIds = await this.carregarPorIds(this.revisoesService, idsRevisoes);
        const revisoesRelacionadas = await this.buscarRelacionadosPorCampos(this.revisoesService, salesOrderId, [
          "salesOrder",
          "salesOrderId",
          "solicitacaoOrcamento",
          "solicitacaoOrcamentoId"
        ]);
        const revisoesPorNumero = await this.buscarRevisoesPorNumeroBase(this.revisoesService, numeroBaseAtual);

        const revisoesLegadasPorIds = await this.carregarPorIds(this.revisoesLegadoService, idsRevisoes);
        const revisoesLegadasRelacionadas = await this.buscarRelacionadosPorCampos(this.revisoesLegadoService, salesOrderId, [
          "salesOrder",
          "salesOrderId",
          "solicitacaoOrcamento",
          "solicitacaoOrcamentoId"
        ]);
        const revisoesLegadasPorNumero = await this.buscarRevisoesPorNumeroBase(this.revisoesLegadoService, numeroBaseAtual);

        const revisoesLista = [
          ...(Array.isArray(revisoesPorIds) ? revisoesPorIds : []),
          ...(Array.isArray(revisoesRelacionadas) ? revisoesRelacionadas : []),
          ...(Array.isArray(revisoesPorNumero) ? revisoesPorNumero : [])
        ];

        const revisoesLegadas = [
          ...(Array.isArray(revisoesLegadasPorIds) ? revisoesLegadasPorIds : []),
          ...(Array.isArray(revisoesLegadasRelacionadas) ? revisoesLegadasRelacionadas : []),
          ...(Array.isArray(revisoesLegadasPorNumero) ? revisoesLegadasPorNumero : [])
        ];

        const totalRevisoesEncontradas =
          (Array.isArray(revisoesLista) ? revisoesLista.length : 0) +
          (Array.isArray(revisoesLegadas) ? revisoesLegadas.length : 0);

        let revisoesExtras = [];
        let revisoesLegadasExtras = [];
        if (totalRevisoesEncontradas <= 1 && numeroBaseAtual) {
          revisoesExtras = await this.buscarRevisoesFallbackGlobal(this.revisoesService, numeroBaseAtual);
          revisoesLegadasExtras = await this.buscarRevisoesFallbackGlobal(this.revisoesLegadoService, numeroBaseAtual);
        }

        const revisoesOriginais = [];
        if (this.formulario?.id) {
          revisoesOriginais.push({
            ...this.formulario,
            revisao: this.normalizarCodigoRevisao(this.formulario.revisao || this.formulario.version || this.formulario.ultimaRevisao || "ORIGINAL"),
            dateGenerate: this.formulario.dateGenerate || this.formulario.dataCriacao || "",
            statusDescription: this.formulario.statusDescription || "",
            _revisaoAtual: true
          });
        }

        const mapaRevisoes = new Map();
        [
          ...revisoesOriginais,
          ...(Array.isArray(revisoesLista) ? revisoesLista : []),
          ...(Array.isArray(revisoesLegadas) ? revisoesLegadas : []),
          ...(Array.isArray(revisoesExtras) ? revisoesExtras : []),
          ...(Array.isArray(revisoesLegadasExtras) ? revisoesLegadasExtras : [])
        ]
          .map((item) => this.mapearRevisao(item))
          .forEach((item) => {
            const id = item?.id || item?._id || item?.code || item?.codigo || "sem-id";
            const chave = `${item._revisaoAtual ? "ATUAL" : "HIST"}:${id}:${item.revisao || "SEM-REV"}:${item.dateGenerate || "SEM-DATA"}`;
            if (!mapaRevisoes.has(chave)) mapaRevisoes.set(chave, item);
          });

        const revisoesOrdenadas = Array.from(mapaRevisoes.values()).filter((item) => {
          if (!numeroBaseAtual) return true;
          const baseItem = this.extrairNumeroPropostaBase(
            item?.numeroProposta || item?.numeroSolicitacao || item?.codigo || item?.code || ""
          );
          return !baseItem || baseItem === numeroBaseAtual;
        }).sort((a, b) => {
          if (a._revisaoAtual && !b._revisaoAtual) return -1;
          if (!a._revisaoAtual && b._revisaoAtual) return 1;

          const numeroB = this.extrairNumeroRevisao(b.revisao);
          const numeroA = this.extrairNumeroRevisao(a.revisao);
          if (numeroB !== numeroA) return numeroB - numeroA;

          const dataB = new Date(b.dateGenerate || 0).getTime();
          const dataA = new Date(a.dateGenerate || 0).getTime();
          return dataB - dataA;
        });

        this.revisoes = this.garantirHistoricoMinimoRevisoes(revisoesOrdenadas);
      } catch (error) {
        this.revisoes = [];
      }
    },

    limparFormulario() {
      this.formulario = criarFormularioPadrao();
      this.formulario.origemSchema = "SalesOrder";
      this.aplicarOrigemDaEmpresaNoFormulario();
      this.sincronizarCamposSchemaFormulario();
      this.propostasTecnicas = [];
      this.propostasComerciais = [];
      this.followUps = [];
      this.revisoes = [];
    },

    async abrirFormulario() {
      this.modoFormulario = "create";
      this.limparFormulario();
      await this.carregarClientes();
      this.recalcularCamposPreco();
      this.normalizarCamposNumericosParaInput();
      this.formularioAberto = true;
    },

    async fecharFormulario() {
      this.debugSolicitacao("fecharFormulario:start", {
        formularioId: this.formulario?.id,
        status: this.formulario?.status,
        statusDescription: this.formulario?.statusDescription,
        modoFormulario: this.modoFormulario
      });

      await fecharModalComRecarregamentoGrid({
        fecharModal: () => {
          this.formularioAberto = false;
          this.modoFormulario = "create";
          this.limparFormulario();
        },
        recarregarGrid: () => this.carregarOrcamentos()
      });

      this.debugSolicitacao("fecharFormulario:end", {
        totalGrid: Array.isArray(this.orcamentos) ? this.orcamentos.length : 0
      });
    },

    async aoAtualizarFormularioAberto(valor) {
      this.debugSolicitacao("update:formularioAberto", { valor });

      if (valor) {
        this.formularioAberto = true;
        return;
      }

      await this.fecharFormulario();
    },

    adicionarItem(novoItem = null) {
      if (!this.podeAdicionarEditarItensSolicitacao(this.formulario)) {
        this.$notfy?.warning("Não é permitido incluir itens quando a solicitação está em PEDIDO COLOCADO");
        return;
      }
      const itensAtual = Array.isArray(this.formulario.itens) ? this.formulario.itens : [];
      const itemBase = normalizarItem({
        ...criarItemPadrao(),
        ...(novoItem || {})
      });
      const itemNormalizado = normalizarItem({
        ...itemBase,
        ...recalcularCamposComerciaisItem(itemBase)
      });
      this.$set(this.formulario, "itens", [...itensAtual, itemNormalizado]);
      this.aplicarCamposDeItens();
    },

    removerItem(index) {
      if (!this.podeExcluirItensSolicitacao(this.formulario)) {
        this.$notfy?.warning("Não é permitido excluir itens para esta solicitação");
        return;
      }
      if (!Array.isArray(this.formulario.itens)) return;
      if (!Number.isInteger(index) || index < 0 || index >= this.formulario.itens.length) return;
      const novosItens = this.formulario.itens.filter((_, i) => i !== index);
      this.$set(this.formulario, "itens", novosItens);
      this.aplicarCamposDeItens();
    },

    atualizarItem({ index, item } = {}) {
      if (!this.podeAdicionarEditarItensSolicitacao(this.formulario)) {
        this.$notfy?.warning("Não é permitido editar itens quando a solicitação está em PEDIDO COLOCADO");
        return;
      }
      if (!Array.isArray(this.formulario.itens)) return;
      if (!Number.isInteger(index) || index < 0 || index >= this.formulario.itens.length) return;

      const itemBase = normalizarItem({
        ...criarItemPadrao(),
        ...(item || {})
      });
      const itemNormalizado = normalizarItem({
        ...itemBase,
        ...recalcularCamposComerciaisItem(itemBase)
      });

      const novosItens = [...this.formulario.itens];
      this.$set(novosItens, index, itemNormalizado);
      this.$set(this.formulario, "itens", novosItens);
      this.aplicarCamposDeItens();
    },

    normalizarItemNumerico(item) {
      if (!item) return;
      const itemFormatado = {
        ...item,
        quantidade: parseNumero(item.quantidade ?? item.qty),
        qty: parseNumero(item.qty ?? item.quantidade),
        valorDisponivel: formatarNumeroInput(item.valorDisponivel),
        valorDisponivelTotal: formatarNumeroInput(item.valorDisponivelTotal),
        porcentagemPIS: formatarNumeroInput(item.porcentagemPIS),
        porcentagemCOFINS: formatarNumeroInput(item.porcentagemCOFINS),
        ki: formatarNumeroInput(item.ki, 3),
        kidoCusto: formatarNumeroInput(item.kidoCusto),
        porcentagemISS: formatarNumeroInput(item.porcentagemISS || item.porcentagemIIS),
        porcentagemIIS: formatarNumeroInput(item.porcentagemIIS || item.porcentagemISS),
        porcentagemICMSVenda: formatarNumeroInput(item.porcentagemICMSVenda),
        pocentagemIPIVenda: formatarNumeroInput(item.pocentagemIPIVenda || item.porcentagemIPI),
        porcentagemIPI: formatarNumeroInput(item.porcentagemIPI || item.pocentagemIPIVenda),
        kv: formatarNumeroInput(item.kv, 3),
        precoVenda_sIPI_cICMS: formatarNumeroInput(item.precoVenda_sIPI_cICMS),
        precoVenda_cIPI_cICMS: formatarNumeroInput(item.precoVenda_cIPI_cICMS),
        precoVenda_sIPI_sICMS: formatarNumeroInput(item.precoVenda_sIPI_sICMS),
        precoVenda_cISS: formatarNumeroInput(item.precoVenda_cISS),
        valorICMS: formatarNumeroInput(item.valorICMS),
        valorIPI: formatarNumeroInput(item.valorIPI),
        vlrTotal: formatarNumeroInput(item.vlrTotal || item.valorTotal),
        _mirror_valor_sIPI_cICMS: formatarNumeroInput(item._mirror_valor_sIPI_cICMS)
      };
      const recalculado = recalcularCamposComerciaisItem(itemFormatado);
      const normalizado = normalizarItem({ ...itemFormatado, ...recalculado });
      Object.assign(item, normalizado);
      this.aplicarCamposDeItens();
    },

    aplicarCamposDeItens() {
      if (this.aplicandoCamposItens) return;

      const campos = calcularCamposDeItens(this.formulario.itens);
      if (!campos) return;

      this.aplicandoCamposItens = true;
      try {
        this.formulario.precoVenda_sIPI_cICMS = campos.precoVenda_sIPI_cICMS;
        this.formulario.precoVenda_cIPI_cICMS = campos.precoVenda_cIPI_cICMS;
        this.formulario.valorICMS = campos.valorICMS;
        this.formulario.valorIPI = campos.valorIPI;
        this.formulario.valorDisponivel = campos.valorDisponivel;
        this.recalcularCamposPreco();
        this.normalizarCamposNumericosParaInput();
      } finally {
        this.aplicandoCamposItens = false;
      }
    },

    async carregarOrcamentos() {
      try {
        this.carregando = true;
        const companySiteIdAtivo = await this.obterCompanySiteIdAtivo();

        const [responseLegado] = await Promise.allSettled([
          this.salesOrderLegadoService.getAll(1, 500, "", "", null, null, null, "code")
        ]);
        const legados = responseLegado.status === "fulfilled"
          ? normalizaListaSalesOrder(responseLegado.value, this.statusDescricaoPorId)
            .map((item) => ({
              ...item,
              origemSchema: "SalesOrder",
              _listKey: this.obterChaveListaOrcamento(item, "SalesOrder")
            }))
            .filter((item) => this.registroCarregavel(item))
            .filter((item) => !this.registroEstaDeletado(item))
            .filter((item) => this.registroPertenceAoCompanySiteAtivo(item, companySiteIdAtivo))
          : [];

        const mapa = new Map();
        [...legados].forEach((registro) => {
          const chaveLista = registro._listKey || this.obterChaveListaOrcamento(registro, registro.origemSchema);
          mapa.set(chaveLista, registro);
        });

        this.orcamentos = this.ordenarOrcamentosLista(Array.from(mapa.values()));

        this.debugSolicitacao("carregarOrcamentos:statusResumo", {
          total: this.orcamentos.length,
          amostra: this.orcamentos.slice(0, 10).map((item) => ({
            id: item?.id,
            code: item?.code,
            status: item?.status,
            statusDescription: item?.statusDescription,
            job: item?.job || item?.jobNome || item?.project || item?.projectId || null
          }))
        });
      } catch (error) {
        this.$notfy?.error("Erro ao carregar solicitações de orçamento");
        console.error(error);
      } finally {
        this.carregando = false;
      }
    },

    async abrirOrcamentoPorModo(orcamento = {}, modo = "edit") {
      let base = { ...orcamento };
      const id = orcamento?.id;
      const origemSchema = "SalesOrder";
      const serviceDetalhe = this.salesOrderLegadoService;
      const resolverIdRelacionamento = (valor) => {
        if (!valor) return null;
        if (typeof valor === "object") {
          return (
            valor?.id ||
            valor?._id ||
            valor?._currentData?.id ||
            valor?._currentData?._id ||
            valor?.value ||
            valor?.code ||
            valor?.codigo ||
            null
          );
        }
        return valor;
      };

      if (id) {
        try {
          const response = await serviceDetalhe.getById(id);
          const detalhe = response?.data?.data || response?.data || {};
          base = { ...base, ...detalhe, origemSchema };
        } catch (error) {
          // fallback para os dados da lista
        }
      }

      this.modoFormulario = modo;
      this.formulario = {
        ...criarFormularioPadrao(),
        ...base,
        origemSchema,
        numeroProposta: base?.numeroProposta || base?.numeroSolicitacao || base?.code || "",
        itens: Array.isArray(base.itens)
          ? base.itens.filter((item) => item && typeof item === "object").map((item) => normalizarItem(item))
          : (Array.isArray(base.Itens)
            ? base.Itens.filter((item) => item && typeof item === "object").map((item) => normalizarItem(item))
            : [])
        };
      this.formulario.cliente =
        resolverIdRelacionamento(base?.cliente) ||
        resolverIdRelacionamento(base?.clienteID) ||
        resolverIdRelacionamento(base?.clienteId) ||
        resolverIdRelacionamento(this.formulario.cliente) ||
        null;
        this.formulario.observacao = String(base?.observacao ?? base?.observacoes ?? this.formulario.observacao ?? "");
      const referenciaClienteValor = String(base?.cliente_referencia ?? base?.referenciaCliente ?? "").trim();
      this.formulario.cliente_referencia = referenciaClienteValor;
      this.formulario.referenciaCliente = referenciaClienteValor;
      const codigoOrigem =
        this.formulario.numeroProposta ||
        this.formulario.numeroSolicitacao ||
        this.formulario.codigo ||
        this.formulario.code ||
        "";
      const origemInferidaPorCodigo = this.determinarOrigemPorCodigo(codigoOrigem);

      if (origemInferidaPorCodigo) {
        this.formulario.origem = origemInferidaPorCodigo;
      } else if (!this.formulario?.id && !this.formulario?.origem) {
        this.aplicarOrigemDaEmpresaNoFormulario();
      }
      this.sincronizarCamposSchemaFormulario();
      this.formulario.dateGenerate = this.normalizarDataParaInput(
        base?.dateGenerate || base?.dataGeracao || base?.dataCriacao || base?.createdAt || ""
      );
      this.formulario.dataSolicitacao = this.normalizarDataParaInput(
        base?.dataSolicitacao || base?._mirror_dataSolicitacao || base?.dataCriacao || base?.createdAt || ""
      );
      this.formulario.dataDesejada = this.normalizarDataParaInput(
        base?.dataDesejada || base?._mirror_dataDesejada || base?.dataDespacho || ""
      );
      this.formulario.dataDespacho = this.formulario.dataDesejada;
      this.formulario.dataConclusao = this.normalizarDataParaInput(
        base?.dataConclusao || base?._mirror_dataConclusao || ""
      );

      this.formulario.clienteNome = base?.clienteNome || this.getClienteNomePorId(this.formulario.cliente);
      this.formulario.clienteCnpj = this.getClienteCnpjPorId(this.formulario.cliente);
      this.formulario.vendedorNome =
        base?.vendedorNome || this.getColaboradorNomePorId(this.formulario.vendedor);
      this.formulario.orcamentistaNome =
        base?.orcamentistaNome || this.getColaboradorNomePorId(this.formulario.orcamentista);

      // tipo de equipamento
      const tipoDados = this.resolverDadosTipoEquipamento(base);
      this.formulario.tipoDeEquipamento = tipoDados.tipoId || null;
      this.formulario.tipoDeEquipamentoSigla = tipoDados.tipoSigla;
      this.formulario.tipoDeEquipamentoDescricao = tipoDados.tipoDescricao;
      this.formulario._mirror_tipoDeEquipamento = tipoDados.tipoObj || tipoDados.tipoDescricao || "";
      this.formulario.numeroProposta = this.formulario.origemSchema === "SalesOrder"
        ? (base?.codigo || base?.code || base?.numeroSolicitacao || base?.numeroProposta || "")
        : (base?.numeroProposta || base?.numeroSolicitacao || base?.codigo || base?.code || this.gerarNumeroProposta(this.formulario));

      const promessas = [
        this.formulario.cliente
          ? this.carregarContatosDoCliente(this.formulario.cliente)
          : Promise.resolve(),
        this.carregarJobRelacionado(this.formulario.id, base)
      ];

      // Apenas recarrega clientes se a lista estiver vazia (cache)
      if (!Array.isArray(this.clientes) || this.clientes.length === 0) {
        promessas.push(this.carregarClientes());
      }

      await Promise.all(promessas);

      const clienteSelecionadoId = this.formulario?.cliente;
      const clienteExisteNaLista = Array.isArray(this.clientes)
        ? this.clientes.some((item) => (item?.id || item?._id) === clienteSelecionadoId)
        : false;

      if (clienteSelecionadoId && !clienteExisteNaLista) {
        try {
          const responseCliente = await this.clienteService.getById(clienteSelecionadoId);
          const clienteBruto = this.obterRegistroResponse(responseCliente);
          const clienteSelecionado = clienteBruto
            ? {
                ...clienteBruto,
                id: clienteBruto?.id || clienteBruto?._id || null,
                _id: clienteBruto?._id || clienteBruto?.id || null
              }
            : null;
          if (clienteSelecionado?.id || clienteSelecionado?._id) {
            this.clientes = [clienteSelecionado, ...(Array.isArray(this.clientes) ? this.clientes : [])];
          }
        } catch (_) {
          // mantém fluxo de abertura mesmo sem conseguir carregar o cliente específico
        }
      }

      this.formulario.clienteCnpj =
        this.getClienteCnpjPorId(this.formulario.cliente) ||
        base?.clienteCnpj ||
        base?.cnpj ||
        "";

      this.sincronizarContatosDoFormulario();

      this.aplicarCamposComerciaisDoSchemaSemItens(base);

      this.recalcularCamposPreco();
      this.normalizarCamposNumericosParaInput();
      if (this.formulario.id) {
        this.carregarSubEntidades(this.formulario.id);
      }
      this.formularioAberto = true;
    },

    async editarOrcamento(orcamento = {}) {
      await this.abrirOrcamentoPorModo(orcamento, "edit");
    },

    async visualizarOrcamento(orcamento = {}) {
      await this.abrirOrcamentoPorModo(orcamento, "view");
    },

    async salvarOrcamento(opcoes = {}) {
      const {
        fecharAposSalvar = false,
        notificarSucesso = true,
        recarregarGrid = true,
        recarregarFormulario = true
      } = opcoes || {};

      try {
        this.carregando = true;

        this.debugSalvarOrcamento("formulario-inicial", {
          id: this.formulario.id,
          code: this.formulario.code,
          numeroProposta: this.formulario.numeroProposta,
          cliente: this.formulario.cliente,
          clienteNome: this.formulario.clienteNome,
          status: this.formulario.status,
          statusDescription: this.formulario.statusDescription,
          contato: this.formulario.contato,
          contatoNome: this.formulario.contatoNome,
          contatoTecnico: this.formulario.contatoTecnico,
          contatoTecnicoNome: this.formulario.contatoTecnicoNome,
          descricao: this.formulario.projetoDescricao || this.formulario.descricao,
          tipoDeEquipamento: this.formulario.tipoDeEquipamento,
          tipoDeEquipamentoSigla: this.formulario.tipoDeEquipamentoSigla
        });

        this.sincronizarCamposSchemaFormulario();

        if (!this.formulario.cliente) {
          this.$notfy?.warning("Preencha o campo \"Cliente\" para continuar");
          this.debugSalvarOrcamento("validacao-sem-cliente");
          return;
        }

        let clienteAtual = this.clientes.find((item) => item?.id === this.formulario.cliente) || null;
        if (!clienteAtual && this.formulario.cliente) {
          try {
            const responseCliente = await this.clienteService.getById(this.formulario.cliente);
            clienteAtual = this.obterRegistroResponse(responseCliente);
          } catch (_) {
            clienteAtual = null;
          }
        }

        if (!clienteAtual || !this.clientePossuiCamposObrigatorios(clienteAtual)) {
          this.$notfy?.warning("Cliente inválido. É necessário cliente com CNPJ, Razão Social, Nome Fantasia e Inscrição Estadual cadastrados.");
          this.debugSalvarOrcamento("validacao-cliente-invalido", clienteAtual);
          return;
        }

        if (!this.tipoEquipamentoSelecionadoEhValido()) {
          this.$notfy?.warning("É obrigatório selecionar um Tipo de Equipamento válido para a empresa informada");
          this.debugSalvarOrcamento("validacao-sem-tipo-equipamento");
          return;
        }

        if (!this.formulario.vendedor) {
          this.$notfy?.warning("O campo \"Vendedor\" é obrigatório para gravar a Solicitação de Orçamento");
          this.debugSalvarOrcamento("validacao-sem-vendedor");
          return;
        }

        if (!this.formulario.orcamentista) {
          this.$notfy?.warning("O campo \"Orçamentista\" é obrigatório para gravar a Solicitação de Orçamento");
          this.debugSalvarOrcamento("validacao-sem-orcamentista");
          return;
        }

        const statusIdResolvido = this.resolverStatusId(
          this.formulario.status,
          this.formulario.statusDescription
        ) || this.formulario.status || STATUS_EM_EXECUCAO_ID;
        const contatoComercialIdResolvido = this.resolverContatoId(
          this.formulario.contato,
          this.formulario.contatoNome || this.formulario.contatoComercialNome
        );
        const contatoTecnicoIdResolvido = this.resolverContatoId(
          this.formulario.contatoTecnico,
          this.formulario.contatoTecnicoNome
        );
        const servicePersistencia = this.salesOrderLegadoService;
        const schemaPersistencia = "SalesOrder";

        this.debugSalvarOrcamento("relacoes-resolvidas", {
          origemSchema: this.formulario.origemSchema,
          schemaPersistencia,
          statusOriginal: this.formulario.status,
          statusDescription: this.formulario.statusDescription,
          statusIdResolvido,
          contatoOriginal: this.formulario.contato,
          contatoNome: this.formulario.contatoNome || this.formulario.contatoComercialNome,
          contatoComercialIdResolvido,
          contatoTecnicoOriginal: this.formulario.contatoTecnico,
          contatoTecnicoNome: this.formulario.contatoTecnicoNome,
          contatoTecnicoIdResolvido,
          statusOpcoes: (this.statusOpcoes || []).map((item) => ({ id: item.id, description: item.description })),
          contatosCliente: (this.contatosCliente || []).map((item) => ({ id: item.id, nome: item.nome }))
        });

        this.atualizarNumeroPropostaComSiglaAtual(this.formulario.tipoDeEquipamentoSigla);

        const referenciaClienteValor = String(this.formulario.cliente_referencia ?? this.formulario.referenciaCliente ?? "").trim();
        this.formulario.cliente_referencia = referenciaClienteValor;
        this.formulario.referenciaCliente = referenciaClienteValor;

        let payload = gerarPayloadPersistencia(this.formulario);
        const idsItensPersistidos = await this.persistirItensSalesOrder(this.formulario.itens);
        payload.Itens = idsItensPersistidos;
        this.formulario.Itens = idsItensPersistidos;
        const isSalesOrderLegado = schemaPersistencia === "SalesOrder";
        const usuarioLogadoId = await this.obterUsuarioLogadoId();
        const companySiteIdAtivo = await this.obterCompanySiteIdAtivo();
        const tipoDados = this.resolverDadosTipoEquipamento(this.formulario);
        const tipoDescricaoCompleta = tipoDados.tipoDescricao;
        const codigoPropostaAtual = this.formulario.numeroProposta ||
          this.formulario.codigo ||
          this.formulario.code ||
          this.formulario.numeroSolicitacao ||
          this.gerarNumeroProposta(this.formulario);
        payload.numeroProposta = codigoPropostaAtual || "";
        payload.codigo = codigoPropostaAtual || "";
        payload.code = codigoPropostaAtual || "";
        payload.numeroSolicitacao = codigoPropostaAtual || "";

        if (!payload.id) {
          const numeroGerado = await this.gerarNumeroPropostaPorSequenciaSchema(
            "SalesOrder",
            tipoDados.tipoSigla || this.formulario.tipoDeEquipamentoSigla || ""
          );

          payload.numeroProposta = numeroGerado;
          payload.codigo = numeroGerado;
          payload.code = numeroGerado;
          payload.numeroSolicitacao = numeroGerado;

          this.formulario.numeroProposta = numeroGerado;
          this.formulario.codigo = numeroGerado;
          this.formulario.code = numeroGerado;
          this.formulario.numeroSolicitacao = numeroGerado;
        }

        payload.companySiteId =
          this.resolverCompanySiteIdPorOrigem(this.formulario.origem) ||
          this.formulario.companySiteId ||
          payload.companySiteId ||
          companySiteIdAtivo ||
          undefined;
        this.formulario.companySiteId = payload.companySiteId;
        payload.status = statusIdResolvido;
        payload.statusDescription =
          this.statusDescricaoPorId[statusIdResolvido] ||
          this.formulario.statusDescription ||
          STATUS_EM_EXECUCAO_DESC;
        payload.clienteNome = this.formulario.clienteNome || this.getClienteNomePorId(payload.cliente);
        payload.vendedorNome = this.formulario.vendedorNome || this.getColaboradorNomePorId(this.formulario.vendedor);
        payload.orcamentistaNome = this.formulario.orcamentistaNome || this.getColaboradorNomePorId(this.formulario.orcamentista);
        const contatoComercialObj = this.getContatoPorId(contatoComercialIdResolvido);
        const contatoTecnicoObj = this.getContatoPorId(contatoTecnicoIdResolvido);
        payload.contato = contatoComercialIdResolvido || undefined;
        payload.contatoComercial = contatoComercialIdResolvido || undefined;
        payload.contatoComercialNome =
          contatoComercialObj?.nome ||
          this.formulario.contatoNome ||
          this.formulario.contatoComercialNome ||
          "";
        payload.contatoComercialEmail = this.formulario.email || this.formulario.contatoComercialEmail || "";
        payload.contatoComercialTelefone = this.formulario.telefone || this.formulario.contatoComercialTelefone || "";
        payload.contatoTecnico = contatoTecnicoIdResolvido || undefined;
        payload.contatoTecnicoNome = contatoTecnicoObj?.nome || this.formulario.contatoTecnicoNome || "";
        payload.contatoTecnicoTelefone = contatoTecnicoObj?.telefone || this.formulario.contatoTecnicoTelefone || "";
        payload.contatoTecnicoCelular = contatoTecnicoObj?.celular || this.formulario.contatoTecnicoCelular || "";
        payload.contatoTecnicoEmail = contatoTecnicoObj?.email || this.formulario.contatoTecnicoEmail || "";
        payload.tipoDeEquipamento = tipoDados.tipoId || null;
        payload.tipoDeEquipamentoSigla = tipoDados.tipoSigla || "";
        payload.tipoDeEquipamentoDescricao = tipoDados.tipoDescricao || "";
        payload._mirror_tipoDeEquipamento = isSalesOrderLegado
          ? (tipoDados.tipoId || "")
          : (tipoDados.tipoDescricao || "");

        if (isSalesOrderLegado) {
          payload._mirror_tipo = tipoDados.tipoSigla || this.formulario.tipoDeEquipamentoSigla || tipoDescricaoCompleta || "";
          payload._mirror_valor_sIPI_cICMS = parseNumero(
            payload.precoVenda_sIPI_cICMS || payload.valorDisponivel || 0
          );
          payload.owners =
            Array.isArray(payload.owners) && payload.owners.length
              ? payload.owners
              : (usuarioLogadoId ? [usuarioLogadoId] : undefined);

          payload.dateGenerate = payload.dateGenerate
            ? UtilDateTime.toFormatUTC({ dateTime: payload.dateGenerate })
            : UtilDateTime.todayUTC();

          payload.statusDescription = String(payload.statusDescription || STATUS_EM_EXECUCAO_DESC).toUpperCase();
          payload.liberar = Boolean(payload.liberar);

          payload.codigo = payload.codigo || codigoPropostaAtual || "";
          payload = this.sanitizarPayloadSalesOrder(payload);
        }

        if (!payload.contato) delete payload.contato;
        if (!payload.contatoComercial) delete payload.contatoComercial;
        if (!payload.contatoTecnico) delete payload.contatoTecnico;
        if (!payload.companySiteId) delete payload.companySiteId;
        if (!payload.owners) delete payload.owners;

        let payloadParaSalvar = payload;
        let payloadComplementarPosCreate = null;

        if (isSalesOrderLegado && !payload.id) {
          payloadParaSalvar = {
            liberar: Boolean(payload.liberar),
            codigo: payload.codigo || payload.code || payload.numeroProposta || "",
            companySiteId: payload.companySiteId,
            status: payload.status || STATUS_EM_EXECUCAO_ID,
            statusDescription: String(payload.statusDescription || STATUS_EM_EXECUCAO_DESC).toUpperCase(),
            dateGenerate: payload.dateGenerate,
            _mirror_tipo: payload._mirror_tipo || tipoDescricaoCompleta || this.formulario.tipoDeEquipamentoSigla || "",
            _mirror_tipoDeEquipamento: payload._mirror_tipoDeEquipamento,
            cliente: payload.cliente,
            vendedor: payload.vendedor,
            orcamentista: payload.orcamentista,
            owners: payload.owners
          };

          if (payload.contatoComercial) payloadParaSalvar.contatoComercial = payload.contatoComercial;
          if (payload.contatoTecnico) payloadParaSalvar.contatoTecnico = payload.contatoTecnico;
          payloadParaSalvar.cliente_referencia = String(payload.cliente_referencia ?? payload.referenciaCliente ?? "").trim();

          payloadComplementarPosCreate = this.sanitizarPayloadSalesOrder({ ...payload });
          delete payloadComplementarPosCreate.id;
        }

        this.debugSalvarOrcamento("payload-final", payloadParaSalvar);

        const response = await servicePersistencia.insertOrUpdate(payloadParaSalvar);
        const retornoComErroLegado =
          isSalesOrderLegado && (
            Number(response?.data?.status || 0) >= 400 ||
            response?.success === false
          );

        let registroSalvo = this.obterRegistroResponse(response) || payloadParaSalvar;

        if (retornoComErroLegado) {
          this.debugSalvarOrcamento("retorno-legacy-action-com-erro", response?.data);
          const codigoBusca = payload.codigo || payload.code || payload.numeroProposta;
          if (codigoBusca) {
            try {
              const responseBusca = await servicePersistencia.search("codigo", codigoBusca, 1, 1, null, "Equals");
              const listaBusca = this.extrairListaResponse(responseBusca);
              if (Array.isArray(listaBusca) && listaBusca.length > 0) {
                registroSalvo = listaBusca[0];
              }
            } catch (_) {
              // fallback para payload local
            }
          }
        }
        const registroSalvoId = this.obterIdRegistro(registroSalvo) || payload.id || null;

        if (payloadComplementarPosCreate && registroSalvoId) {
          try {
            await servicePersistencia.insertOrUpdate({
              ...payloadComplementarPosCreate,
              id: registroSalvoId
            });
          } catch (erroComplementar) {
            this.debugSalvarOrcamento("aviso-update-complementar", {
              id: registroSalvoId,
              message: erroComplementar?.message,
              data: erroComplementar?.response?.data || erroComplementar?.data
            });
          }
        }

        if (registroSalvoId) {
          try {
            const responseDetalhe = await servicePersistencia.getById(registroSalvoId);
            registroSalvo = this.obterRegistroResponse(responseDetalhe) || registroSalvo;
          } catch (errorDetalhe) {
            this.debugSalvarOrcamento("aviso-sem-detalhe-pos-save", {
              registroSalvoId,
              message: errorDetalhe?.message
            });
          }
        }

        if (notificarSucesso) {
          this.$notfy?.success("Solicitação salva com sucesso");
        }
        this.atualizarOrcamentoNaLista(registroSalvo, schemaPersistencia);

        // Não recarregue toda a lista - atualizarOrcamentoNaLista() já atualizou
        // if (recarregarGrid) {
        //   await this.carregarOrcamentos();
        // }

        if (recarregarFormulario && registroSalvoId) {
          // Atualiza formulário com dados salvos sem recarregar tudo
          this.formulario = {
            ...this.formulario,
            ...registroSalvo,
            observacao: String(registroSalvo?.observacao ?? registroSalvo?.observacoes ?? this.formulario?.observacao ?? ""),
            id: registroSalvoId
          };
          // Recarrega sub-entidades se necessário
          if (registroSalvoId) {
            try {
              await this.carregarSubEntidades(registroSalvoId);
            } catch (_) {
              // ignorar erros ao carregar sub-entidades
            }
          }
        }

        if (fecharAposSalvar) {
          await this.fecharFormulario();
        }

        return registroSalvo;
      } catch (error) {
        this.debugSalvarOrcamento("erro-save", {
          message: error?.message,
          responseStatus: error?.response?.status,
          responseData: error?.response?.data,
          responseErrors: error?.response?.data?.data,
          stack: error?.stack
        });
        this.$notfy?.error("Erro ao salvar solicitação de orçamento");
        console.error(error);
        throw error;
      } finally {
        this.carregando = false;
      }
    },

    async gerarRevisao() {
      if (!this.formulario?.id) {
        this.$notfy?.warning("Salve a Solicitação de Orçamento antes de gerar revisão");
        return;
      }

      if (!this.statusOrcamentoConcluido(this.formulario)) {
        this.$notfy?.warning("Só é possível gerar revisão para solicitação concluída");
        return;
      }

      if (!this.tipoEquipamentoSelecionadoEhValido()) {
        this.$notfy?.warning("É obrigatório selecionar um Tipo de Equipamento válido para a empresa informada");
        return;
      }

      if (this.registroCancelado(this.formulario)) {
        this.$notfy?.warning("Não é possível gerar revisão para uma solicitação cancelada");
        return;
      }

      if (this.registroPossuiJobAssociado(this.formulario)) {
        this.$notfy?.warning("Não é possível gerar revisão para uma solicitação com Job / Pedido Colocado");
        return;
      }

      const confirmar = window.confirm("Deseja gerar uma nova revisão desta solicitação?");
      if (!confirmar) return;

      try {
        this.carregando = true;
        this.sincronizarCamposSchemaFormulario();

        const revisaoAtualNormalizada = this.normalizarCodigoRevisao(
          this.formulario.revisao || this.formulario.version || this.formulario.ultimaRevisao || "ORIGINAL"
        );
        const numeroRevisaoAtual = this.extrairNumeroRevisao(revisaoAtualNormalizada);

        // Sempre salva no histórico o estado ATUAL da solicitação.
        // Ex.: 1º clique salva ORIGINAL, 2º clique salva RV01, 3º clique salva RV02...
        const revisaoParaSalvar = revisaoAtualNormalizada;

        // E a solicitação principal avança para a próxima revisão.
        const proximaRevisao = this.formatarCodigoRevisao(numeroRevisaoAtual + 1);
        const dataRevisaoUTC = UtilDateTime.todayUTC();
        const dataRevisao = this.normalizarDataParaInput(dataRevisaoUTC);
        const numeroPropostaAtual = this.formulario.origemSchema === "SalesOrder"
          ? (this.formulario.codigo || this.formulario.code || this.formulario.numeroSolicitacao || this.formulario.numeroProposta || "")
          : (this.formulario.numeroProposta || this.formulario.numeroSolicitacao || this.formulario.codigo || this.formulario.code || "");
        const numeroPropostaBase = this.extrairNumeroPropostaBase(numeroPropostaAtual);
        const numeroProposta = this.montarNumeroPropostaComRevisao(numeroPropostaBase || numeroPropostaAtual, proximaRevisao);
        const codigoBase = this.formulario.code || this.formulario.codigo || numeroPropostaAtual;
        const codigoHistorico = `${codigoBase}-${revisaoParaSalvar}-${Date.now()}`;
        const tipoDados = this.resolverDadosTipoEquipamento(this.formulario);
        const tipoEquipamentoDescricao = tipoDados.tipoDescricao;
        const payloadBase = gerarPayloadPersistencia(this.formulario);
        const dataSolicitacaoUTC = this.formulario.dataSolicitacao
          ? UtilDateTime.toFormatUTC({ dateTime: this.formulario.dataSolicitacao })
          : "";
        const dataDesejadaUTC = this.formulario.dataDesejada
          ? UtilDateTime.toFormatUTC({ dateTime: this.formulario.dataDesejada })
          : "";
        const dataConclusaoUTC = this.formulario.dataConclusao
          ? UtilDateTime.toFormatUTC({ dateTime: this.formulario.dataConclusao })
          : "";
        const payloadRevisao = {
          ...payloadBase,
          numeroProposta: numeroPropostaAtual,
          code: codigoHistorico,
          codigo: codigoHistorico,
          numeroSolicitacao: numeroPropostaAtual,
          revisao: revisaoParaSalvar,
          version: revisaoParaSalvar,
          dateGenerate: dataRevisaoUTC,
          codigoOriginal: codigoBase,
          codigoNovo: codigoBase,
          codeAnterior: codigoBase,
          status: this.formulario.status,
          statusDescription: this.formulario.statusDescription,
          cliente: this.formulario.cliente || null,
          clienteNome: this.formulario.clienteNome || this.getClienteNomePorId(this.formulario.cliente),
          contatoComercial: this.formulario.contato || null,
          contatoComercialNome: this.formulario.contatoNome || this.formulario.contatoComercialNome || "",
          contatoTecnico: this.formulario.contatoTecnico || null,
          contatoTecnicoNome: this.formulario.contatoTecnicoNome || "",
          _mirror_tipo: tipoDados.tipoSigla || "",
          tipoDeEquipamento: tipoDados.tipoId || null,
          tipoDeEquipamentoSigla: tipoDados.tipoSigla || "",
          tipoDeEquipamentoDescricao: tipoDados.tipoDescricao || "",
          _mirror_tipoDeEquipamento: tipoEquipamentoDescricao,
          _mirror_projeto: this.formulario.projetoDescricao || "",
          projetoDescricao: this.formulario.projetoDescricao || "",
          dataSolicitacao: dataSolicitacaoUTC,
          _mirror_dataSolicitacao: dataSolicitacaoUTC,
          dataDesejada: dataDesejadaUTC,
          _mirror_dataDesejada: dataDesejadaUTC,
          dataConclusao: dataConclusaoUTC,
          _mirror_dataConclusao: dataConclusaoUTC,
          valorDisponivel: parseNumero(this.formulario.valorDisponivel),
          porcentagemPIS: parseNumero(this.formulario.porcentagemPIS),
          porcentagemCOFINS: parseNumero(this.formulario.porcentagemCOFINS),
          ki: parseNumero(this.formulario.ki),
          kidoCusto: parseNumero(this.formulario.kidoCusto),
          porcentagemISS: parseNumero(this.formulario.porcentagemISS || this.formulario.porcentagemIIS),
          porcentagemICMSVenda: parseNumero(this.formulario.porcentagemICMSVenda),
          pocentagemIPIVenda: parseNumero(this.formulario.pocentagemIPIVenda || this.formulario.porcentagemIPI),
          precoVenda_sIPI_cICMS: parseNumero(this.formulario.precoVenda_sIPI_cICMS),
          precoVenda_cIPI_cICMS: parseNumero(this.formulario.precoVenda_cIPI_cICMS),
          precoVenda_sIPI_sICMS: parseNumero(this.formulario.precoVenda_sIPI_sICMS),
          precoVenda_cISS: parseNumero(this.formulario.precoVenda_cISS),
          kv: parseNumero(this.formulario.kv),
          _mirror_valor_sIPI_cICMS: parseNumero(this.formulario.precoVenda_sIPI_cICMS || 0),
          snapshot: JSON.stringify({
            ...this.formulario,
            ...payloadBase,
            id: this.formulario.id,
            code: codigoBase,
            codigo: codigoBase,
            revisao: revisaoParaSalvar,
            version: revisaoParaSalvar,
            ultimaRevisao: revisaoParaSalvar,
            numeroProposta: numeroPropostaAtual,
            numeroSolicitacao: numeroPropostaAtual,
            dateGenerate: dataRevisaoUTC,
            status: this.formulario.status,
            statusDescription: this.formulario.statusDescription,
            itens: Array.isArray(this.formulario.itens) ? this.formulario.itens : []
          }),
          salesOrder: this.formulario.id,
          salesOrderId: this.formulario.id,
          solicitacaoOrcamento: this.formulario.id,
          solicitacaoOrcamentoId: this.formulario.id
        };

        delete payloadRevisao.id;

        let revisaoSalva = null;
        try {
          const responseRevisao = await this.revisoesService.insertOrUpdate(payloadRevisao);
          revisaoSalva = this.obterRegistroResponse(responseRevisao) || payloadRevisao;
        } catch (_) {
          const responseRevisao = await this.revisoesLegadoService.insertOrUpdate(payloadRevisao);
          revisaoSalva = this.obterRegistroResponse(responseRevisao) || payloadRevisao;
        }

        const revisaoSalvaId = this.obterIdRegistro(revisaoSalva);
        if (revisaoSalvaId) {
          const revisoesAtuais = [
            ...(Array.isArray(this.formulario.revisoes) ? this.formulario.revisoes : []),
            ...(Array.isArray(this.formulario.revisoesComerciais) ? this.formulario.revisoesComerciais : [])
          ].filter(Boolean);
          try {
            await this.atualizarVinculoRevisoesNoSalesOrder([...revisoesAtuais, revisaoSalvaId]);
          } catch (_) {
            // fallback por busca direta do histórico
          }
        }

        const servicePersistencia = this.salesOrderLegadoService;
        const statusEmExecucaoId = this.resolverStatusId(STATUS_EM_EXECUCAO_ID, STATUS_EM_EXECUCAO_DESC) || STATUS_EM_EXECUCAO_ID;
        const statusEmExecucaoDescription = this.statusDescricaoPorId[statusEmExecucaoId] || STATUS_EM_EXECUCAO_DESC;
        let payloadAtualizacao = {
          ...gerarPayloadPersistencia(this.formulario),
          id: this.formulario.id,
          codigo: numeroProposta,
          code: numeroProposta,
          numeroSolicitacao: numeroProposta,
          numeroProposta: numeroProposta,
          revisao: proximaRevisao,
          version: proximaRevisao,
          ultimaRevisao: proximaRevisao,
          dateGenerate: dataRevisaoUTC,
          status: statusEmExecucaoId,
          statusDescription: statusEmExecucaoDescription,
          revisoes: Array.isArray(this.formulario.revisoes) ? this.formulario.revisoes : [],
          tipoDeEquipamento: tipoDados.tipoId || null,
          tipoDeEquipamentoSigla: tipoDados.tipoSigla || "",
          tipoDeEquipamentoDescricao: tipoDados.tipoDescricao || "",
          _mirror_tipoDeEquipamento: tipoEquipamentoDescricao
        };

        if (this.formulario.origemSchema === "SalesOrder") {
          payloadAtualizacao._mirror_tipo = tipoDados.tipoSigla || tipoEquipamentoDescricao || "";
          payloadAtualizacao._mirror_tipoDeEquipamento = tipoDados.tipoId || "";
          payloadAtualizacao = this.sanitizarPayloadSalesOrder(payloadAtualizacao);
        }

        await servicePersistencia.insertOrUpdate(payloadAtualizacao);

        this.formulario.revisao = proximaRevisao;
        this.formulario.version = proximaRevisao;
        this.formulario.ultimaRevisao = proximaRevisao;
        this.formulario.code = numeroProposta;
        this.formulario.codigo = numeroProposta;
        this.formulario.numeroProposta = numeroProposta;
        this.formulario.numeroSolicitacao = numeroProposta;
        this.formulario.dateGenerate = dataRevisao;
        this.formulario.status = statusEmExecucaoId;
        this.formulario.statusDescription = statusEmExecucaoDescription;

        await this.carregarSubEntidades(this.formulario.id);
        // Não recarregue toda a lista - atualizarOrcamentoNaLista() suficiente
        // await this.carregarOrcamentos();
        this.atualizarOrcamentoNaLista({ ...this.formulario, ...payloadAtualizacao }, "SalesOrder");
        this.$notfy?.success("Revisão gerada com sucesso");
      } catch (error) {
        const mensagem = error?.response?.data?.message || "Erro ao gerar revisão da solicitação";
        this.$notfy?.error(mensagem);
        console.error(error);
      } finally {
        this.carregando = false;
      }
    },

    async cancelarOrcamento(orcamento = {}) {
      const id = orcamento?.id;
      if (!id) {
        this.$notfy?.warning("Não foi possível identificar o registro para cancelamento");
        return;
      }

      if (this.registroCancelado(orcamento)) {
        this.$notfy?.warning("Esta solicitação já está cancelada");
        return;
      }

      if (this.registroPossuiJobAssociado(orcamento)) {
        this.$notfy?.warning("Solicitações com Job / Pedido Colocado não podem ser canceladas");
        return;
      }

      const confirmar = window.confirm("Tem certeza que deseja cancelar esta solicitação?");
      if (!confirmar) return;

      try {
        this.carregando = true;

        const origemSchema = "SalesOrder";
        const servicePersistencia = this.salesOrderLegadoService;

        let registroAtual = { ...orcamento };
        try {
          const response = await servicePersistencia.getById(id);
          registroAtual = {
            ...registroAtual,
            ...(this.obterRegistroResponse(response) || {})
          };
        } catch (_) {
          // mantém dados da lista
        }

        const statusCancelado = this.obterStatusPorDescricao(["cancelado", "cancel"]);
        const payloadCancelamento = {
          ...gerarPayloadPersistencia({
            ...criarFormularioPadrao(),
            ...registroAtual,
            numeroProposta: registroAtual?.numeroProposta || registroAtual?.numeroSolicitacao || registroAtual?.code || ""
          }),
          id,
          numeroProposta: registroAtual?.numeroProposta || registroAtual?.numeroSolicitacao || registroAtual?.code || "",
          codigo: registroAtual?.codigo || registroAtual?.code || registroAtual?.numeroProposta || registroAtual?.numeroSolicitacao || "",
          code: registroAtual?.code || registroAtual?.codigo || registroAtual?.numeroProposta || registroAtual?.numeroSolicitacao || "",
          numeroSolicitacao: registroAtual?.numeroSolicitacao || registroAtual?.code || registroAtual?.codigo || registroAtual?.numeroProposta || "",
          status: statusCancelado?.id || registroAtual?.status,
          statusDescription: statusCancelado?.description || "Cancelado",
          tipoDeEquipamento: registroAtual?.tipoDeEquipamento || null,
          tipoDeEquipamentoSigla: registroAtual?.tipoDeEquipamentoSigla || "",
          tipoDeEquipamentoDescricao: registroAtual?.tipoDeEquipamentoDescricao || "",
          _mirror_tipoDeEquipamento: registroAtual?._mirror_tipoDeEquipamento || ""
        };

        await servicePersistencia.insertOrUpdate(payloadCancelamento);

        if (this.formulario?.id === id) {
          this.formulario.status = payloadCancelamento.status;
          this.formulario.statusDescription = payloadCancelamento.statusDescription;
        }

        this.atualizarOrcamentoNaLista({
          ...registroAtual,
          ...payloadCancelamento,
          origemSchema
        }, origemSchema);

        this.$notfy?.success("Solicitação cancelada com sucesso");
        // Não recarregue toda a lista - atualizarOrcamentoNaLista() já atualizou
        // await this.carregarOrcamentos();
      } catch (error) {
        this.$notfy?.error("Erro ao cancelar solicitação de orçamento");
        console.error(error);
      } finally {
        this.carregando = false;
      }
    }
  },
  watch: {
    "formulario.valorDisponivel"() {
      this.recalcularCamposPreco();
    },
    "formulario.ki"() {
      this.recalcularCamposPreco();
    },
    "formulario.porcentagemISS"() {
      this.recalcularCamposPreco();
    },
    "formulario.porcentagemIIS"() {
      this.recalcularCamposPreco();
    },
    "formulario.porcentagemICMSVenda"() {
      this.recalcularCamposPreco();
    },
    "formulario.precoVenda_sIPI_cICMS"() {
      this.recalcularCamposPreco();
    },
    "formulario.itens": {
      deep: true,
      handler() {
        if (this.aplicandoCamposItens) return;
        this.aplicarCamposDeItens();
      }
    }
  },
  async mounted() {
    await Promise.all([
      this.carregarDadosUsuario(),
      this.carregarStatus(),
      this.carregarColaboradores(),
      this.carregarTiposDeEquipamento()
    ]);
    await this.carregarOrcamentos();
  },
  beforeDestroy() {
    if (this.debounceBuscaClientes) {
      clearTimeout(this.debounceBuscaClientes);
      this.debounceBuscaClientes = null;
    }
  }
};
</script>

<template>
  <main class="c-main">
    <CartaoListaDeSolicitacoes
      :carregando="carregando"
      :orcamentos="orcamentos"
      :clientes="clientes"
      :usuario-nome="usuarioNome"
      :pode-criar="podeCriarSolicitacao"
      :pode-editar="podeEditarSolicitacao"
      :pode-deletar="podeCancelarSolicitacao"
      @novo="abrirFormulario"
      @recarregar="carregarOrcamentos"
      @visualizar="visualizarOrcamento"
      @editar="editarOrcamento"
    />

    <!-- Dialog: campos faltantes para gerar Job -->
    <v-dialog v-model="dialogCamposFaltantes" max-width="520" persistent>
      <v-card>
        <v-card-title class="headline error white--text py-3">
          <v-icon color="white" class="mr-2">mdi-alert-circle-outline</v-icon>
          Campos Obrigatórios não Preenchidos
        </v-card-title>
        <v-card-text class="pt-4">
          <p class="body-1 mb-3">
            {{ contextoCamposFaltantes === "conclusao" ? "Para Concluir a Solicitação, os seguintes campos precisam ser preenchidos:" : "Para gerar o Job, os seguintes campos precisam ser preenchidos:" }}
          </p>
          <v-list dense>
            <div v-for="(secao, indexSecao) in camposFaltantesAgrupados" :key="'sec-' + indexSecao">
              <v-subheader class="pl-0 font-weight-bold caption text-uppercase primary--text">
                {{ secao.nome }}
              </v-subheader>
              <v-list-item
                v-for="(campo, indexCampo) in secao.campos"
                :key="'campo-' + indexSecao + '-' + indexCampo"
                dense
                class="pl-2"
              >
                <v-list-item-icon class="mr-2 my-auto" style="margin-top:auto;margin-bottom:auto;">
                  <v-icon small color="error">mdi-circle-small</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="body-2">{{ campo.label }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list>
        </v-card-text>
        <v-card-actions class="pb-4 px-4">
          <v-spacer />
          <v-btn color="primary" @click="dialogCamposFaltantes = false">
            <v-icon left>mdi-arrow-left</v-icon>
            OK, Voltar para Edição
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ModalSolicitacaoDeOrcamento
      :formulario-aberto="formularioAberto"
      :modo-formulario="modoFormulario"
      :formulario="formulario"
      :status-opcoes="statusOpcoes"
      :clientes="clientes"
      :clientes-carregando="clientesCarregando"
      :cliente-busca="buscaClientes"
      :contatos-cliente="contatosCliente"
      :vendedores="vendedores"
      :orcamentistas="orcamentistas"
      :contatos-comerciais-cliente="contatosComerciaisCliente"
      :contatos-tecnicos-cliente="contatosTecnicosCliente"
      :tipos-de-equipamento="tiposDeEquipamento"
      :abrir-novo-contato="abrirNovoContato"
      :novo-contato="novoContato"
      :follow-ups="followUps"
      :revisoes="revisoes"
      :carregando="carregando"
      :somente-leitura="modoFormulario === 'view'"
      :campos-bloqueados="modoFormulario === 'edit' && statusOrcamentoConcluido(formulario)"
      :status-concluido="statusOrcamentoConcluido(formulario)"
      :has-job-associado="registroPossuiJobAssociado(formulario)"
      :pode-gerar-job="podeGerarJob"
      :pode-concluir-solicitacao="podeConcluirSolicitacao"
      @update:formularioAberto="aoAtualizarFormularioAberto"
      @update:abrirNovoContato="abrirNovoContato = $event"
      @fechar="fecharFormulario"
      @salvar="salvarOrcamento"
      @gerar-capa-proposta="gerarCapaProposta"
      @normalizar-numericos="normalizarCamposFinanceiros"
      @buscar-clientes="aoBuscarClientes"
      @selecionar-cliente="selecionarCliente"
      @selecionar-contato="selecionarContato"
      @selecionar-contato-tecnico="selecionarContatoTecnico"
      @selecionar-tipo-equipamento="selecionarTipoEquipamento"
      @alterar-empresa="alterarEmpresa"
      @criar-contato="criarContato"
      @novo-followup="novoFollowUp"
      @editar-followup="editarFollowUp"
      @deletar-followup="deletarFollowUp"
      @gerar-revisao="gerarRevisao"
      @gerar-job="gerarJob"
      @concluir-solicitacao="concluirSolicitacao"
      @add-item="adicionarItem"
      @update-item="atualizarItem"
      @remove-item="removerItem"
      @normalizar-item="normalizarItemNumerico"
    />
  </main>
</template>

<style scoped>
.c-main {
  display: grid;
  gap: 15px;
}
</style>
